/* eslint-disable require-yield */
/* eslint-disable default-case */
import * as signalR from "@microsoft/signalr";
import { eventChannel, END, delay } from "redux-saga";
import {
  all,
  call,
  fork,
  put,
  select,
  take,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { push } from "react-router-redux";

import {
  Utils,
  Database,
  Cookies,
  AppConfig,
  Enums,
  SessionStorage,
  Events,
} from "../../helpers";
import {
  AppActionTypes,
  CategoriesActionTypes,
  SignalRTypes,
  SlotsActionTypes,
  SportEventsActionTypes,
  MembersActionTypes,
  AuthActionTypes,
  SearchActionTypes,
  SportTypesActionTypes,
} from "../actions";
import { JackpotLevel } from "../../helpers/enums";

export function* requests() {
  let hubConnection = null;
  let kioskBannerHubConnection = null;
  let BooongoHubConnection = null;
  let booongoChannel = null;
  let memberChangeChannel = null;
  let JackpotHubConnection = null;
  let MemberChangeConnection = null;
  let VirtualFeedHubConnection = null;
  let SAWFeedHubConnection = null;
  let LuckyNumbersFeedHubConnection = null;
  let StaticFeedHubConnection = null;
  let LiveFeedHubConnection = null;
  let jackpotChannel = null;
  let staticChannel = null;
  let liveChannel = null;
  let luckyNumbersChannel = null;
  let spinAndWinChannel = null;
  let virtualChannel = null;
  let chan = null;
  let kioskChan = null;
  let connectInterval = null;
  let connectJPInterval = null;
  let connectKioskBannerInterval = null;
  let isActive = true;
  let isActiveJP = true;
  let jackpotSrTimeout = null;
  let jackpotListener;
  const excludedRoutes = ["/spinandwinwheel"];

  function connect() {
    switch (hubConnection.connectionState) {
      case "Disconnected":
        hubConnection
          .start()
          .then(() => {
            if (hubConnection.onopen) hubConnection.onopen();
          })
          .catch((error) => {
            hubConnection.onopen(error);
          });
        break;
    }
  }

  function connectkioskBannerHub() {
    switch (kioskBannerHubConnection.connectionState) {
      case "Disconnected":
        kioskBannerHubConnection
          .start()
          .then(() => {
            if (kioskBannerHubConnection.onopen)
              kioskBannerHubConnection.onopen();
          })
          .catch((error) => {
            kioskBannerHubConnection.onopen(error);
          });
        break;
    }
  }

  function booongoConnect() {
    switch (BooongoHubConnection.connectionState) {
      case "Disconnected":
        BooongoHubConnection.start()
          .then(() => {
            if (BooongoHubConnection.onopen) BooongoHubConnection.onopen();
          })
          .catch((error) => {
            BooongoHubConnection.onopen(error);
          });
        break;
    }
  }

  function memberChangeConnect() {
    switch (MemberChangeConnection.connectionState) {
      case "Disconnected":
        MemberChangeConnection.start()
          .then(() => {
            if (MemberChangeConnection.onopen) MemberChangeConnection.onopen();
          })
          .catch((error) => {
            MemberChangeConnection.onopen(error);
          });
        break;
    }
  }

  function jackpotConnect() {
    switch (JackpotHubConnection.connectionState) {
      case "Disconnected":
        JackpotHubConnection.start()
          .then(() => {
            if (JackpotHubConnection.onopen) JackpotHubConnection.onopen();
          })
          .catch((error) => {
            JackpotHubConnection.onopen(error);
          });
        break;
    }
  }

  function virtualConnect() {
    switch (VirtualFeedHubConnection.connectionState) {
      case "Disconnected":
        try {
          VirtualFeedHubConnection.start()
            .then(() => {
              if (VirtualFeedHubConnection.onopen)
                VirtualFeedHubConnection.onopen();
            })
            .catch((error) => {
              VirtualFeedHubConnection.onopen(error);
            });
          break;
        } catch {
          setTimeout(() => virtualConnect(), 5000);
        }
    }
  }

  function spinAndWinConnect() {
    window.log("spinAndWinConnect");
    switch (SAWFeedHubConnection.connectionState) {
      case "Disconnected":
        try {
          SAWFeedHubConnection.start()
            .then(() => {
              if (SAWFeedHubConnection.onopen) SAWFeedHubConnection.onopen();
            })
            .catch((error) => {
              SAWFeedHubConnection.onopen(error);
            });
          break;
        } catch {
          setTimeout(() => spinAndWinConnect(), 5000);
        }
    }
  }

  function luckyNumberConnect() {
    switch (LuckyNumbersFeedHubConnection.connectionState) {
      case "Disconnected":
        try {
          LuckyNumbersFeedHubConnection.start()
            .then(() => {
              if (LuckyNumbersFeedHubConnection.onopen)
                LuckyNumbersFeedHubConnection.onopen();
            })
            .catch((error) => {
              LuckyNumbersFeedHubConnection.onopen(error);
            });
          break;
        } catch {
          setTimeout(() => luckyNumberConnect(), 5000);
        }
    }
  }

  function staticConnect() {
    switch (StaticFeedHubConnection.connectionState) {
      case "Disconnected":
        try {
          StaticFeedHubConnection.start()
            .then(() => {
              if (StaticFeedHubConnection.onopen)
                StaticFeedHubConnection.onopen();
            })
            .catch((error) => {
              StaticFeedHubConnection.onopen(error);
            });
          break;
        } catch {
          setTimeout(() => staticConnect(), 5000);
        }
    }
  }

  function liveConnect() {
    switch (LiveFeedHubConnection.connectionState) {
      case "Disconnected":
        try {
          LiveFeedHubConnection.start()
            .then(() => {
              if (LiveFeedHubConnection.onopen) LiveFeedHubConnection.onopen();
            })
            .catch((error) => {
              LiveFeedHubConnection.onopen(error);
            });
          break;
        } catch {
          setTimeout(() => liveConnect(), 5000);
        }
    }
  }

  function handleSignalrExpiresOnClick(emitter, e, timeout) {
    if (isActive) {
      clearTimeout(connectInterval);
      connectInterval = setTimeout(() => {
        isActive = false;
        emitter({ name: "timeout" });
      }, timeout);
    } else {
      isActive = true;
      clearTimeout(connectInterval);
      emitter({ name: "reconnect" });
    }
  }

  function handleJPExpiresOnClick(emitter, e, timeout) {
    if (isActiveJP) {
      clearTimeout(jackpotSrTimeout);
      const timeoutExpires = AppConfig.JackpotSRTimeout * 60 * 1000;
      jackpotSrTimeout = setTimeout(() => {
        isActiveJP = false;
        console.log("jackpot time out");
        emitter({ name: "OnJackpotTimeout" });
      }, timeoutExpires);
    } else {
      isActiveJP = true;
      clearTimeout(jackpotSrTimeout);
      emitter({ name: "JackpotReconnect" });
    }
  }

  const options = {
    accessTokenFactory: () => {
      return "jwt token";
    },
    httpClient: {
      post: (url, httpOptions) => {
        httpOptions.headers = {
          ...httpOptions.headers,
          ContentType: "NewHeader",
        };
        httpOptions.method = "POST";
        httpOptions.url = url;

        return httpOptions;
      },
    },
  };

  function* registerSignalRChannel() {
    return eventChannel((emitter) => {
      if (!hubConnection) {
        hubConnection = new signalR.HubConnectionBuilder()
          .configureLogging(
            Utils.InDev ? signalR.LogLevel.Information : signalR.LogLevel.None
          )
          //.withUrl(AppConfig.srAddress)
          .withUrl(AppConfig.srAddress, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
          })
          //.withUrl(AppConfig.srAddress, options)
          .withAutomaticReconnect()
          .build();
        hubConnection.serverTimeoutInMilliseconds = 60000;
      }
      hubConnection.onreconnected((connectionId) => {
        window.log(
          "*******ON RECONNECTED*******: Feed Changes - client reconnected. connectionId ",
          connectionId
        );
        emitter({
          name: "onConnect",
          connectionState: hubConnection.state,
        });
        //Set no activity timout for 4.5 minutes
        clearTimeout(connectInterval);
      });

      hubConnection.onreconnecting((error) => {
        error &&
          window.log(
            `*******ON RECONNECTING*******:  Feed Changes - client connect error ${error.toString()}, reconnecting... `
          );

        emitter({
          name: "onDisconnect",
          connectionState: hubConnection && hubConnection.state,
          response: error,
        });
      });
      hubConnection.onopen = (error) => {
        const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
        let timeout = (tokenExpiresMinutes || 5) * 60 * 1000;
        if (!error) {
          emitter({
            name: "onConnect",
            connectionState: hubConnection.state,
          });

          //Set no activity timout for 4.5 minutes
          // clearTimeout(connectInterval);
          // connectInterval = setTimeout(() => {
          // 	if (isActive) {
          // 		isActive = false
          // 		emitter({ name: 'timeout' })
          // 	}
          // }, timeout);
          // document.addEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e, timeout));
        } else {
          setTimeout(() => {
            connect();
          }, 5000);
          emitter({
            name: "onConnectFailed",
            connectionState: hubConnection.state,
            response: error,
          });
          error &&
            console.log("*******CONNECTION FAILED*******: ", error.toString());
        }
      };

      hubConnection.onclose((error) => {
        emitter({
          name: "onDisconnect",
          connectionState: hubConnection && hubConnection.state,
          response: error,
        });
        error && console.log("*******ON DISCONNECT*******: ", error.toString());
      });

      hubConnection.on("OnConnectionSlow", (data) => {
        emitter({
          name: "onConnectionSlow",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnError", (data) => {
        emitter({
          name: "onError",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnSportTypes", (data) => {
        emitter({
          name: "onSportTypes",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnWeekMatchDaysWeb", (data) => {
        emitter({
          name: "onWeekMatchDays",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnLiveDefaultSportType", (data) => {
        emitter({
          name: "onLiveDefaultSportType",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnMainTournamentEvents", (data) => {
        emitter({
          name: "onMainTournamentEvents",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnUpcomingDraws", (data) => {
        emitter({
          name: "onUpcomingDraws",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnDrawsCategoriesAndTournaments", (data) => {
        emitter({
          name: "onDrawsCategoriesAndTournaments",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnEventResult", (data) => {
        emitter({
          name: "onEventResult",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnDrawOdds", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnSuggestedBalls", (data) => {
        emitter({
          name: "onSuggestedBalls",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnSportCategories", (data) => {
        emitter({
          name: "onSportCategories",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnSportEvents", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnTopBets", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnAllBetTypes", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnSportEventsByDate", (data) => {
        emitter({
          name: "onSportEventsByDate",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnEventOddFieldData", (data) => {
        emitter({
          name: "onEventOddFieldData",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnJoinGroup", (data) => {
        emitter({
          name: "onJoinGroup",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnPartGroup", (data) => {
        emitter({
          name: "onPartGroup",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      // hubConnection.on("OnFeedChanges", data => {
      // 	emitter({
      // 		name: 'onFeedChanges',
      // 		connectionState: hubConnection.state,
      // 		response: Utils.inflate(data)
      // 	})
      // })

      hubConnection.on("OnSportEventsChange", (data) => {
        emitter({
          name: "onSportEventsChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnEventOddsChange", (data) => {
        emitter({
          name: "onEventOddsChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnEventOddGroupsChange", (data) => {
        emitter({
          name: "onEventOddGroupsChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnEventOddFieldsChange", (data) => {
        emitter({
          name: "onEventOddFieldsChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnEventScoreChange", (data) => {
        emitter({
          name: "onEventScoreChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnSportTournamentsChange", (data) => {
        emitter({
          name: "onSportTournamentsChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnTopBetTypesChange", (data) => {
        emitter({
          name: "onTopBetTypesChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnSportTypesChange", (data) => {
        emitter({
          name: "onSportTypesChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnSportCategoriesChange", (data) => {
        emitter({
          name: "onSportCategoriesChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnSportTopLeaguesChange", (data) => {
        emitter({
          name: "onSportTopLeaguesChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnUpcomingEventsChange", (data) => {
        emitter({
          name: "onUpcomingEventsChange",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnAllCacheData", (data) => {
        emitter({
          name: "onAllCacheData",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnSearchedData", (data) => {
        emitter({
          name: "onSearchedData",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      hubConnection.on("OnProducerDown", (data) => {
        emitter({
          name: "OnProducerDown",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnProducerUp", (data) => {
        emitter({
          name: "OnProducerUp",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnKironEventsList", (data) => {
        emitter({
          name: "OnKironEventsList",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });
      hubConnection.on("OnKironEvent", (data) => {
        emitter({
          name: "OnKironEvent",
          connectionState: hubConnection.state,
          response: Utils.inflate(data),
        });
      });

      //Connect to hub
      connect();

      // The subscriber must return an unsubscribe function
      return () => {
        hubConnection.stop();
        console.log("*******hubConnection.stop(); return*******: ");
        hubConnection = null;
        clearTimeout(connectInterval);
        document.removeEventListener("click", (e) =>
          handleSignalrExpiresOnClick(emitter, e)
        );
      };
    });
  }

  function* registerKioskBannerChannel() {
    return eventChannel((emitter) => {
      if (!kioskBannerHubConnection) {
        kioskBannerHubConnection = new signalR.HubConnectionBuilder()
          .configureLogging(
            Utils.InDev ? signalR.LogLevel.Information : signalR.LogLevel.None
          )
          //.withUrl(AppConfig.srAddress)
          .withUrl(AppConfig.bannerSR, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
          })
          //.withUrl(AppConfig.srAddress, options)
          .withAutomaticReconnect()
          .build();
        kioskBannerHubConnection.serverTimeoutInMilliseconds = 60000;
      }
      kioskBannerHubConnection.onreconnected((connectionId) => {
        window.log(
          "*******ON RECONNECTED*******: Banner Hub - client reconnected. connectionId ",
          connectionId
        );
        emitter({
          name: "onConnectBannerHub",
          connectionState: kioskBannerHubConnection.state,
        });
        //Set no activity timout for 4.5 minutes
        clearTimeout(connectKioskBannerInterval);
      });

      kioskBannerHubConnection.onreconnecting((error) => {
        error &&
          window.log(
            `*******ON RECONNECTING*******:  Banner Hub - client connect error ${error.toString()}, reconnecting... `
          );
        emitter({
          name: "onReconnectBannerHub",
          connectionState: kioskBannerHubConnection.state,
        });
      });
      kioskBannerHubConnection.onopen = (error) => {
        if (!error) {
          console.log("*******SUCCESSFULL Connection to Banner Hub*******");
          emitter({
            name: "onConnectBannerHub",
            connectionState: kioskBannerHubConnection.state,
          });
        } else {
          setTimeout(() => {
            connectkioskBannerHub();
          }, 5000);
          error &&
            console.log("*******CONNECTION FAILED*******: ", error.toString());
        }
      };

      kioskBannerHubConnection.on("OnCurrentBanner", (data) => {
        emitter({
          name: "onCurrentBanner",
          connectionState: kioskBannerHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      kioskBannerHubConnection.on("OnBannerChange", (data) => {
        emitter({
          name: "onBannerChange",
          connectionState: kioskBannerHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      kioskBannerHubConnection.on("OnConfigrationChange", (data) => {
        emitter({
          name: "onConfigrationChange ",
          connectionState: kioskBannerHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      kioskBannerHubConnection.on("OnJoinGroup", (data) => {
        emitter({
          name: "onJoinGroup",
          connectionState: kioskBannerHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      // kioskBannerHubConnection.on("OnWeekMatchDaysWeb", (data) => {
      //   emitter({
      //     name: "onWeekMatchDays",
      //     connectionState: kioskBannerHubConnection.state,
      //     response: Utils.inflate(data),
      //   });
      // });

      //Connect to hub
      connectkioskBannerHub();

      // The subscriber must return an unsubscribe function
      return () => {
        emitter({
          name: "onReconnectBannerHub",
          connectionState: kioskBannerHubConnection.state,
        });
        kioskBannerHubConnection.stop();
        console.log("*******kioskBannerHubConnection.stop(); return*******: ");
        kioskBannerHubConnection = null;
        clearTimeout(connectKioskBannerInterval);
      };
    });
  }

  function* registerBooongoChannel() {
    if (AppConfig.booongoSRAddress) {
      return eventChannel((emitter) => {
        if (!BooongoHubConnection) {
          BooongoHubConnection = new signalR.HubConnectionBuilder()
            .configureLogging(signalR.LogLevel.Information)
            //.withUrl(AppConfig.booongoSRAddress)
            .withUrl(AppConfig.booongoSRAddress, {
              skipNegotiation: true,
              transport: signalR.HttpTransportType.WebSockets,
            })
            .withAutomaticReconnect()
            .build();
          BooongoHubConnection.serverTimeoutInMilliseconds = 60000;
        }
        BooongoHubConnection.onreconnected((connectionId) => {
          console.log(
            "BOOONGO SIGNALR: client reconnected. connectionId ",
            connectionId
          );
          emitter({
            name: "onBooongoConnect",
            connectionState: BooongoHubConnection.state,
          });
          //Set no activity timout for 4.5 minutes
          clearTimeout(connectInterval);
        });

        BooongoHubConnection.onreconnecting((error) => {
          error &&
            console.log(
              `BOOONGO SIGNALRr - client connect error ${error.toString()}, reconnecting... `
            );

          emitter({
            name: "onBooongoDisconnect",
            connectionState: BooongoHubConnection && BooongoHubConnection.state,
            response: error,
          });
        });

        BooongoHubConnection.onopen = (error) => {
          if (!error) {
            emitter({
              name: "onBooongoConnect",
              connectionState: BooongoHubConnection.state,
            });
          } else {
            setTimeout(() => {
              booongoConnect();
            }, 5000);
            emitter({
              name: "onBooongoConnectFailed",
              connectionState: BooongoHubConnection.state,
              response: error,
            });
          }
        };

        BooongoHubConnection.onclose((error) => {
          emitter({
            name: "onBooongoDisconnect",
            connectionState: BooongoHubConnection && BooongoHubConnection.state,
            response: error,
          });
        });

        BooongoHubConnection.on("OnError", (data) => {
          emitter({
            name: "onError",
            connectionState: BooongoHubConnection.state,
            response: Utils.inflate(data),
          });
        });

        BooongoHubConnection.on("OnEntityBalances", (data) => {
          emitter({
            name: "onEntityBalances",
            connectionState: BooongoHubConnection.state,
            response: Utils.inflate(data),
          });
        });
        //Connect to hub
        booongoConnect();

        // The subscriber must return an unsubscribe function
        return () => {
          BooongoHubConnection.stop();
          BooongoHubConnection = null;
        };
      });
    }
  }

  // function handleJackpotClick(emitter) {
  // 	console.log("handleJackpotClick")
  // 	clearTimeout(jackpotSrTimeout);
  // 	const timeoutExpires = AppConfig.JackpotSRTimeout * 60 * 1000;
  // 	window.log(timeoutExpires)
  // 	jackpotSrTimeout = setTimeout(() => {
  // 		console.log("jackpot time out")
  // 		emitter({ name: 'OnJackpotTimeout' })
  // 		//	Events.publish("OnJackpotTimeout");
  // 	}, timeoutExpires);

  // }

  function* registerVirtualFeedChangeChannel() {
    window.log("registerVirtualFeedChangeChannel");
    return eventChannel((emitter) => {
      if (!VirtualFeedHubConnection) {
        VirtualFeedHubConnection = new signalR.HubConnectionBuilder()
          .withUrl(AppConfig.virtualFeedSR, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
          })
          .configureLogging(signalR.LogLevel.Information)
          .withAutomaticReconnect()
          .build();
        VirtualFeedHubConnection.serverTimeoutInMilliseconds = 60000;
        hubConnection = VirtualFeedHubConnection;
      }

      VirtualFeedHubConnection.onreconnected((connectionId) => {
        window.log(
          "*******ON RECONNECTED*******: Virtual Feed Changes - client reconnected. connectionId ",
          connectionId
        );
        emitter({
          name: "onConnect",
          connectionState: VirtualFeedHubConnection.state,
        });
        //Set no activity timout for 4.5 minutes
        clearTimeout(connectInterval);
      });

      VirtualFeedHubConnection.onreconnecting((error) => {
        error &&
          window.log(
            `*******ON RECONNECTING*******:  Virtual Feed Changes - client connect error ${error.toString()}, reconnecting... `
          );

        emitter({
          name: "onDisconnect",
          connectionState:
            VirtualFeedHubConnection && VirtualFeedHubConnection.state,
          response: error,
        });
      });

      VirtualFeedHubConnection.onopen = (error) => {
        const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
        let timeout = (tokenExpiresMinutes || 5) * 60 * 1000;
        if (!error) {
          emitter({
            name: "onConnect",
            connectionState: VirtualFeedHubConnection.state,
          });

          //Set no activity timout for 4.5 minutes
          clearTimeout(connectInterval);
          // connectInterval = setTimeout(() => {
          // 	if (isActive) {
          // 		isActive = false
          // 		emitter({ name: 'timeout' })
          // 	}
          // }, timeout);
          // document.addEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e, timeout));
        } else {
          setTimeout(() => {
            virtualConnect();
          }, 5000);
          emitter({
            name: "onConnectFailed",
            connectionState: VirtualFeedHubConnection.state,
            response: error,
          });
          error &&
            window.log(
              "*******CONNECTION FAILED VIRTUAL*******: ",
              error.toString()
            );
        }
      };

      VirtualFeedHubConnection.onclose((error) => {
        emitter({
          name: "onDisconnect",
          connectionState:
            VirtualFeedHubConnection && VirtualFeedHubConnection.state,
          response: error,
        });
        error &&
          window.log("*******ON DISCONNECT VIRTUAL*******: ", error.toString());
      });

      VirtualFeedHubConnection.on("OnConnectionSlow", (data) => {
        emitter({
          name: "onConnectionSlow",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnError", (data) => {
        emitter({
          name: "onError",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnSportTypes", (data) => {
        emitter({
          name: "onSportTypes",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnWeekMatchDaysWeb", (data) => {
        emitter({
          name: "onWeekMatchDays",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnLiveDefaultSportType", (data) => {
        emitter({
          name: "onLiveDefaultSportType",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnMainTournamentEvents", (data) => {
        emitter({
          name: "onMainTournamentEvents",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnUpcomingDraws", (data) => {
        emitter({
          name: "onUpcomingDraws",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnDrawsCategoriesAndTournaments", (data) => {
        emitter({
          name: "onDrawsCategoriesAndTournaments",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnEventResult", (data) => {
        emitter({
          name: "onEventResult",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnDrawOdds", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnSuggestedBalls", (data) => {
        emitter({
          name: "onSuggestedBalls",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnSportCategories", (data) => {
        emitter({
          name: "onSportCategories",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnSportEvents", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnTopBets", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnAllBetTypes", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnSportEventsByDate", (data) => {
        emitter({
          name: "onSportEventsByDate",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnEventOddFieldData", (data) => {
        emitter({
          name: "onEventOddFieldData",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnJoinGroup", (data) => {
        emitter({
          name: "onJoinGroup",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnPartGroup", (data) => {
        emitter({
          name: "onPartGroup",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      // hubConnection.on("OnFeedChanges", data => {
      // 	emitter({
      // 		name: 'onFeedChanges',
      // 		connectionState: hubConnection.state,
      // 		response: Utils.inflate(data)
      // 	})
      // })

      VirtualFeedHubConnection.on("OnSportEventsChange", (data) => {
        emitter({
          name: "onSportEventsChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnEventOddsChange", (data) => {
        emitter({
          name: "onEventOddsChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnEventOddGroupsChange", (data) => {
        emitter({
          name: "onEventOddGroupsChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnEventOddFieldsChange", (data) => {
        emitter({
          name: "onEventOddFieldsChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnEventScoreChange", (data) => {
        emitter({
          name: "onEventScoreChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnSportTournamentsChange", (data) => {
        emitter({
          name: "onSportTournamentsChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnTopBetTypesChange", (data) => {
        emitter({
          name: "onTopBetTypesChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnSportTypesChange", (data) => {
        emitter({
          name: "onSportTypesChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnSportCategoriesChange", (data) => {
        emitter({
          name: "onSportCategoriesChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnSportTopLeaguesChange", (data) => {
        emitter({
          name: "onSportTopLeaguesChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnUpcomingEventsChange", (data) => {
        emitter({
          name: "onUpcomingEventsChange",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnAllCacheData", (data) => {
        emitter({
          name: "onAllCacheData",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnSearchedData", (data) => {
        emitter({
          name: "onSearchedData",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      VirtualFeedHubConnection.on("OnProducerDown", (data) => {
        emitter({
          name: "OnProducerDown",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnProducerUp", (data) => {
        emitter({
          name: "OnProducerUp",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnKironEventsList", (data) => {
        emitter({
          name: "OnKironEventsList",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      VirtualFeedHubConnection.on("OnKironEvent", (data) => {
        emitter({
          name: "OnKironEvent",
          connectionState: VirtualFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      //Connect to hub
      virtualConnect();

      // The subscriber must return an unsubscribe function
      return () => {
        VirtualFeedHubConnection.stop();
        window.log(
          "*******VirtualFeedChangeHubConnection.stop(); return*******: "
        );

        VirtualFeedHubConnection = null;
        clearTimeout(connectInterval);
        //document.removeEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e));
      };
    });
  }

  function* registerSpinAndWinFeedChangeChannel() {
    window.log("registerSpinAndWinFeedChangeChannel");
    const { signalr } = yield select();
    return eventChannel((emitter) => {
      if (!SAWFeedHubConnection) {
        SAWFeedHubConnection = new signalR.HubConnectionBuilder()
          .withUrl(AppConfig.spinAndWinFeedSR, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
          })
          .configureLogging(signalR.LogLevel.Information)
          .withAutomaticReconnect()
          .build();
        SAWFeedHubConnection.serverTimeoutInMilliseconds = 60000;
        //FeedChangeHubConnection =  SAWFeedHubConnection;
      }

      SAWFeedHubConnection.onreconnected((connectionId) => {
        window.log(
          "*******ON RECONNECTED*******: Spin and Win Feed Changes - client reconnected. connectionId ",
          connectionId
        );
        emitter({
          name: "onConnect",
          connectionState: SAWFeedHubConnection.state,
        });
        //Set no activity timout for 4.5 minutes
        clearTimeout(connectInterval);
      });

      SAWFeedHubConnection.onreconnecting((error) => {
        error &&
          window.log(
            `*******ON RECONNECTING*******:  Spin and Win Feed Changes - client connect error ${error.toString()}, reconnecting... `
          );

        emitter({
          name: "onDisconnect",
          connectionState: SAWFeedHubConnection && SAWFeedHubConnection.state,
          response: error,
        });
      });

      SAWFeedHubConnection.onopen = (error) => {
        const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
        let timeout = (tokenExpiresMinutes || 5) * 60 * 1000;
        if (!error) {
          emitter({
            name: "onConnect",
            connectionState: SAWFeedHubConnection.state,
          });

          //Set no activity timout for 4.5 minutes
          clearTimeout(connectInterval);
          // connectInterval = setTimeout(() => {
          // 	if (isActive) {
          // 		isActive = false
          // 		emitter({ name: 'timeout' })
          // 	}
          // }, timeout);
          // document.addEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e, timeout));
        } else {
          if (!signalr.spinAndWinDisconnectRequested) {
            setTimeout(() => {
              spinAndWinConnect();
            }, 5000);
          }
          emitter({
            name: "onConnectFailed",
            connectionState: SAWFeedHubConnection.state,
            response: error,
          });
          error &&
            window.log(
              "*******CONNECTION FAILED SPIN AND WIN*******: ",
              error.toString()
            );
        }
      };

      SAWFeedHubConnection.onclose((error) => {
        emitter({
          name: "onDisconnect",
          connectionState: SAWFeedHubConnection && SAWFeedHubConnection.state,
          response: error,
        });
        error &&
          window.log(
            "*******ON DISCONNECT SPIN AND WIN*******: ",
            error.toString()
          );
      });

      SAWFeedHubConnection.on("OnConnectionSlow", (data) => {
        emitter({
          name: "onConnectionSlow",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnError", (data) => {
        emitter({
          name: "onError",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnSportTypes", (data) => {
        emitter({
          name: "onSportTypes",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnWeekMatchDaysWeb", (data) => {
        emitter({
          name: "onWeekMatchDays",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnLiveDefaultSportType", (data) => {
        emitter({
          name: "onLiveDefaultSportType",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnMainTournamentEvents", (data) => {
        emitter({
          name: "onMainTournamentEvents",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnUpcomingDraws", (data) => {
        emitter({
          name: "onUpcomingDraws",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnDrawsCategoriesAndTournaments", (data) => {
        emitter({
          name: "onDrawsCategoriesAndTournaments",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnEventResult", (data) => {
        emitter({
          name: "onEventResult",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnDrawOdds", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnSuggestedBalls", (data) => {
        emitter({
          name: "onSuggestedBalls",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnSportCategories", (data) => {
        emitter({
          name: "onSportCategories",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnSportEvents", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnTopBets", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnAllBetTypes", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnSportEventsByDate", (data) => {
        emitter({
          name: "onSportEventsByDate",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnEventOddFieldData", (data) => {
        emitter({
          name: "onEventOddFieldData",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnJoinGroup", (data) => {
        emitter({
          name: "onJoinGroup",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnPartGroup", (data) => {
        emitter({
          name: "onPartGroup",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      // hubConnection.on("OnFeedChanges", data => {
      // 	emitter({
      // 		name: 'onFeedChanges',
      // 		connectionState: hubConnection.state,
      // 		response: Utils.inflate(data)
      // 	})
      // })

      SAWFeedHubConnection.on("OnSportEventsChange", (data) => {
        emitter({
          name: "onSportEventsChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnEventOddsChange", (data) => {
        emitter({
          name: "onEventOddsChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnEventOddGroupsChange", (data) => {
        emitter({
          name: "onEventOddGroupsChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnEventOddFieldsChange", (data) => {
        emitter({
          name: "onEventOddFieldsChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnEventScoreChange", (data) => {
        emitter({
          name: "onEventScoreChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnSportTournamentsChange", (data) => {
        emitter({
          name: "onSportTournamentsChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnTopBetTypesChange", (data) => {
        emitter({
          name: "onTopBetTypesChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnSportTypesChange", (data) => {
        emitter({
          name: "onSportTypesChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnSportCategoriesChange", (data) => {
        emitter({
          name: "onSportCategoriesChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnSportTopLeaguesChange", (data) => {
        emitter({
          name: "onSportTopLeaguesChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnUpcomingEventsChange", (data) => {
        emitter({
          name: "onUpcomingEventsChange",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnAllCacheData", (data) => {
        emitter({
          name: "onAllCacheData",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnSearchedData", (data) => {
        emitter({
          name: "onSearchedData",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      SAWFeedHubConnection.on("OnProducerDown", (data) => {
        emitter({
          name: "OnProducerDown",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnProducerUp", (data) => {
        emitter({
          name: "OnProducerUp",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnKironEventsList", (data) => {
        emitter({
          name: "OnKironEventsList",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      SAWFeedHubConnection.on("OnKironEvent", (data) => {
        emitter({
          name: "OnKironEvent",
          connectionState: SAWFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      //Connect to hub
      spinAndWinConnect();

      // The subscriber must return an unsubscribe function
      return () => {
        SAWFeedHubConnection.stop();
        window.log("*******SAWFeedHubConnection.stop(); return*******: ");

        SAWFeedHubConnection = null;
        clearTimeout(connectInterval);
        //document.removeEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e));
      };
    });
  }

  function* registerLuckyNumbersFeedChangeChannel() {
    window.log("registerLuckyNumbersFeedChangeChannel");
    const { signalr } = yield select();

    return eventChannel((emitter) => {
      if (!LuckyNumbersFeedHubConnection) {
        LuckyNumbersFeedHubConnection = new signalR.HubConnectionBuilder()
          .withUrl(AppConfig.luckyNumbersFeedSR, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
          })
          .configureLogging(signalR.LogLevel.Information)
          .withAutomaticReconnect()
          .build();
        LuckyNumbersFeedHubConnection.serverTimeoutInMilliseconds = 60000;
        //FeedChangeHubConnection = LuckyNumbersFeedHubConnection;
      }

      LuckyNumbersFeedHubConnection.onreconnected((connectionId) => {
        window.log(
          "*******ON RECONNECTED*******: Lucky Numbers Feed Changes - client reconnected. connectionId ",
          connectionId
        );
        emitter({
          name: "onConnect",
          connectionState: LuckyNumbersFeedHubConnection.state,
        });
        //Set no activity timout for 4.5 minutes
        clearTimeout(connectInterval);
      });

      LuckyNumbersFeedHubConnection.onreconnecting((error) => {
        error &&
          window.log(
            `*******ON RECONNECTING*******:  Lucky Numbers Feed Changes - client connect error ${error.toString()}, reconnecting... `
          );

        emitter({
          name: "onDisconnect",
          connectionState:
            LuckyNumbersFeedHubConnection &&
            LuckyNumbersFeedHubConnection.state,
          response: error,
        });
      });

      LuckyNumbersFeedHubConnection.onopen = (error) => {
        const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
        let timeout = (tokenExpiresMinutes || 5) * 60 * 1000;
        if (!error) {
          emitter({
            name: "onConnect",
            connectionState: LuckyNumbersFeedHubConnection.state,
          });

          //Set no activity timout for 4.5 minutes
          clearTimeout(connectInterval);
          // connectInterval = setTimeout(() => {
          // 	if (isActive) {
          // 		isActive = false
          // 		emitter({ name: 'timeout' })
          // 	}
          // }, timeout);
          // document.addEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e, timeout));
        } else {
          if (!signalr.luckyNumbersDisconnectRequested) {
            setTimeout(() => {
              luckyNumberConnect();
            }, 5000);
          }
          emitter({
            name: "onConnectFailed",
            connectionState: LuckyNumbersFeedHubConnection.state,
            response: error,
          });
          error &&
            window.log(
              "*******CONNECTION FAILED LUCKY NUMBERS*******: ",
              error.toString()
            );
        }
      };

      LuckyNumbersFeedHubConnection.onclose((error) => {
        emitter({
          name: "onDisconnect",
          connectionState:
            LuckyNumbersFeedHubConnection &&
            LuckyNumbersFeedHubConnection.state,
          response: error,
        });
        error &&
          window.log(
            "*******ON DISCONNECT LUCKY NUMBERS*******: ",
            error.toString()
          );
      });

      LuckyNumbersFeedHubConnection.on("OnConnectionSlow", (data) => {
        emitter({
          name: "onConnectionSlow",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnError", (data) => {
        emitter({
          name: "onError",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnSportTypes", (data) => {
        emitter({
          name: "onSportTypes",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnWeekMatchDaysWeb", (data) => {
        emitter({
          name: "onWeekMatchDays",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnLiveDefaultSportType", (data) => {
        emitter({
          name: "onLiveDefaultSportType",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnMainTournamentEvents", (data) => {
        emitter({
          name: "onMainTournamentEvents",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnUpcomingDraws", (data) => {
        emitter({
          name: "onUpcomingDraws",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on(
        "OnDrawsCategoriesAndTournaments",
        (data) => {
          emitter({
            name: "onDrawsCategoriesAndTournaments",
            connectionState: LuckyNumbersFeedHubConnection.state,
            response: Utils.inflate(data),
          });
        }
      );

      LuckyNumbersFeedHubConnection.on("OnEventResult", (data) => {
        emitter({
          name: "onEventResult",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnDrawOdds", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnSuggestedBalls", (data) => {
        emitter({
          name: "onSuggestedBalls",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnSportCategories", (data) => {
        emitter({
          name: "onSportCategories",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnSportEvents", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnTopBets", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnAllBetTypes", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnSportEventsByDate", (data) => {
        emitter({
          name: "onSportEventsByDate",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnEventOddFieldData", (data) => {
        emitter({
          name: "onEventOddFieldData",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnJoinGroup", (data) => {
        emitter({
          name: "onJoinGroup",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnPartGroup", (data) => {
        emitter({
          name: "onPartGroup",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      // hubConnection.on("OnFeedChanges", data => {
      // 	emitter({
      // 		name: 'onFeedChanges',
      // 		connectionState: hubConnection.state,
      // 		response: Utils.inflate(data)
      // 	})
      // })

      LuckyNumbersFeedHubConnection.on("OnSportEventsChange", (data) => {
        emitter({
          name: "onSportEventsChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnEventOddsChange", (data) => {
        emitter({
          name: "onEventOddsChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnEventOddGroupsChange", (data) => {
        emitter({
          name: "onEventOddGroupsChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnEventOddFieldsChange", (data) => {
        emitter({
          name: "onEventOddFieldsChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnEventScoreChange", (data) => {
        emitter({
          name: "onEventScoreChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnSportTournamentsChange", (data) => {
        emitter({
          name: "onSportTournamentsChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnTopBetTypesChange", (data) => {
        emitter({
          name: "onTopBetTypesChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnSportTypesChange", (data) => {
        emitter({
          name: "onSportTypesChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnSportCategoriesChange", (data) => {
        emitter({
          name: "onSportCategoriesChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnSportTopLeaguesChange", (data) => {
        emitter({
          name: "onSportTopLeaguesChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnUpcomingEventsChange", (data) => {
        emitter({
          name: "onUpcomingEventsChange",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnAllCacheData", (data) => {
        emitter({
          name: "onAllCacheData",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnSearchedData", (data) => {
        emitter({
          name: "onSearchedData",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnProducerDown", (data) => {
        emitter({
          name: "OnProducerDown",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnProducerUp", (data) => {
        emitter({
          name: "OnProducerUp",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnKironEventsList", (data) => {
        emitter({
          name: "OnKironEventsList",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LuckyNumbersFeedHubConnection.on("OnKironEvent", (data) => {
        emitter({
          name: "OnKironEvent",
          connectionState: LuckyNumbersFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      //Connect to hub
      luckyNumberConnect();

      // The subscriber must return an unsubscribe function
      return () => {
        LuckyNumbersFeedHubConnection.stop();
        window.log(
          "*******LuckyNumbersFeedHubConnection.stop(); return*******: "
        );

        LuckyNumbersFeedHubConnection = null;
        clearTimeout(connectInterval);
        //document.removeEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e));
      };
    });
  }

  function* registerStaticFeedChangeChannel() {
    window.log("registerStaticFeedChangeChannel");
    return eventChannel((emitter) => {
      if (!StaticFeedHubConnection) {
        StaticFeedHubConnection = new signalR.HubConnectionBuilder()
          .withUrl(AppConfig.staticFeedSR, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
          })
          .configureLogging(signalR.LogLevel.Information)
          .withAutomaticReconnect()
          .build();
        StaticFeedHubConnection.serverTimeoutInMilliseconds = 60000;
        hubConnection = StaticFeedHubConnection;
      }

      StaticFeedHubConnection.onreconnected((connectionId) => {
        window.log(
          "*******ON RECONNECTED*******: Static Feed Changes - client reconnected. connectionId ",
          connectionId
        );
        emitter({
          name: "onConnect",
          connectionState: StaticFeedHubConnection.state,
        });
        //Set no activity timout for 4.5 minutes
        clearTimeout(connectInterval);
      });

      StaticFeedHubConnection.onreconnecting((error) => {
        error &&
          window.log(
            `*******ON RECONNECTING*******:  Static Feed Changes - client connect error ${error.toString()}, reconnecting... `
          );

        emitter({
          name: "onDisconnect",
          connectionState:
            StaticFeedHubConnection && StaticFeedHubConnection.state,
          response: error,
        });
      });

      StaticFeedHubConnection.onopen = (error) => {
        const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
        let timeout = (tokenExpiresMinutes || 5) * 60 * 1000;
        if (!error) {
          emitter({
            name: "onConnect",
            connectionState: StaticFeedHubConnection.state,
          });

          //Set no activity timout for 4.5 minutes
          clearTimeout(connectInterval);
          // connectInterval = setTimeout(() => {
          // 	if (isActive) {
          // 		isActive = false
          // 		emitter({ name: 'timeout' })
          // 	}
          // }, timeout);
          // document.addEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e, timeout));
        } else {
          setTimeout(() => {
            staticConnect();
          }, 5000);
          emitter({
            name: "onConnectFailed",
            connectionState: StaticFeedHubConnection.state,
            response: error,
          });
          error &&
            window.log(
              "*******CONNECTION FAILED STATIC LIVE*******: ",
              error.toString()
            );
        }
      };

      StaticFeedHubConnection.onclose((error) => {
        emitter({
          name: "onDisconnect",
          connectionState:
            StaticFeedHubConnection && StaticFeedHubConnection.state,
          response: error,
        });
        error &&
          window.log(
            "*******ON DISCONNECT STATIC LIVE*******: ",
            error.toString()
          );
      });

      StaticFeedHubConnection.on("OnConnectionSlow", (data) => {
        emitter({
          name: "onConnectionSlow",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnError", (data) => {
        emitter({
          name: "onError",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnSportTypes", (data) => {
        emitter({
          name: "onSportTypes",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnWeekMatchDaysWeb", (data) => {
        emitter({
          name: "onWeekMatchDays",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnLiveDefaultSportType", (data) => {
        emitter({
          name: "onLiveDefaultSportType",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnMainTournamentEvents", (data) => {
        emitter({
          name: "onMainTournamentEvents",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnUpcomingDraws", (data) => {
        emitter({
          name: "onUpcomingDraws",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnDrawsCategoriesAndTournaments", (data) => {
        emitter({
          name: "onDrawsCategoriesAndTournaments",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnEventResult", (data) => {
        emitter({
          name: "onEventResult",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnDrawOdds", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnSuggestedBalls", (data) => {
        emitter({
          name: "onSuggestedBalls",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnSportCategories", (data) => {
        emitter({
          name: "onSportCategories",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnSportEvents", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnTopBets", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnAllBetTypes", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnSportEventsByDate", (data) => {
        emitter({
          name: "onSportEventsByDate",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnEventOddFieldData", (data) => {
        emitter({
          name: "onEventOddFieldData",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnJoinGroup", (data) => {
        emitter({
          name: "onJoinGroup",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnPartGroup", (data) => {
        emitter({
          name: "onPartGroup",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      // hubConnection.on("OnFeedChanges", data => {
      // 	emitter({
      // 		name: 'onFeedChanges',
      // 		connectionState: hubConnection.state,
      // 		response: Utils.inflate(data)
      // 	})
      // })

      StaticFeedHubConnection.on("OnSportEventsChange", (data) => {
        emitter({
          name: "onSportEventsChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnEventOddsChange", (data) => {
        emitter({
          name: "onEventOddsChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnEventOddGroupsChange", (data) => {
        emitter({
          name: "onEventOddGroupsChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      StaticFeedHubConnection.on("OnEventOddFieldsChange", (data) => {
        emitter({
          name: "onEventOddFieldsChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnEventScoreChange", (data) => {
        emitter({
          name: "onEventScoreChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnSportTournamentsChange", (data) => {
        emitter({
          name: "onSportTournamentsChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnTopBetTypesChange", (data) => {
        emitter({
          name: "onTopBetTypesChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnSportTypesChange", (data) => {
        emitter({
          name: "onSportTypesChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnSportCategoriesChange", (data) => {
        emitter({
          name: "onSportCategoriesChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnSportTopLeaguesChange", (data) => {
        emitter({
          name: "onSportTopLeaguesChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      StaticFeedHubConnection.on("OnUpcomingEventsChange", (data) => {
        emitter({
          name: "onUpcomingEventsChange",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnAllCacheData", (data) => {
        emitter({
          name: "onAllCacheData",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnSearchedData", (data) => {
        emitter({
          name: "onSearchedData",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnProducerDown", (data) => {
        emitter({
          name: "OnProducerDown",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      StaticFeedHubConnection.on("OnCustomBetOddFieldData", (data) => {
        emitter({
          name: "onCustomBetOddFieldData",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      StaticFeedHubConnection.on("OnProducerUp", (data) => {
        emitter({
          name: "OnProducerUp",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnKironEventsList", (data) => {
        emitter({
          name: "OnKironEventsList",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      StaticFeedHubConnection.on("OnKironEvent", (data) => {
        emitter({
          name: "OnKironEvent",
          connectionState: StaticFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      //Connect to hub
      staticConnect();

      // The subscriber must return an unsubscribe function
      return () => {
        StaticFeedHubConnection.stop();
        window.log(
          "*******LuckyNumbersFeedHubConnection.stop(); return*******: "
        );

        StaticFeedHubConnection = null;
        clearTimeout(connectInterval);
        //document.removeEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e));
      };
    });
  }

  function* registerLiveFeedChangeChannel() {
    window.log("registerLiveFeedChangeChannel");
    return eventChannel((emitter) => {
      if (!LiveFeedHubConnection) {
        LiveFeedHubConnection = new signalR.HubConnectionBuilder()
          .withUrl(AppConfig.liveFeedSR, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
          })
          .configureLogging(signalR.LogLevel.Information)
          .withAutomaticReconnect()
          .build();
        LiveFeedHubConnection.serverTimeoutInMilliseconds = 60000;
        hubConnection = LiveFeedHubConnection;
      }

      LiveFeedHubConnection.onreconnected((connectionId) => {
        window.log(
          "*******ON RECONNECTED*******: Live Feed Changes - client reconnected. connectionId ",
          connectionId
        );
        emitter({
          name: "onConnect",
          connectionState: LiveFeedHubConnection.state,
        });
        //Set no activity timout for 4.5 minutes
        clearTimeout(connectInterval);
      });

      LiveFeedHubConnection.onreconnecting((error) => {
        error &&
          window.log(
            `*******ON RECONNECTING*******:  Live Feed Changes - client connect error ${error.toString()}, reconnecting... `
          );

        emitter({
          name: "onDisconnect",
          connectionState: LiveFeedHubConnection && LiveFeedHubConnection.state,
          response: error,
        });
      });

      LiveFeedHubConnection.onopen = (error) => {
        const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
        let timeout = (tokenExpiresMinutes || 5) * 60 * 1000;
        if (!error) {
          emitter({
            name: "onConnect",
            connectionState: LiveFeedHubConnection.state,
          });

          //Set no activity timout for 4.5 minutes
          clearTimeout(connectInterval);
          // connectInterval = setTimeout(() => {
          // 	if (isActive) {
          // 		isActive = false
          // 		emitter({ name: 'timeout' })
          // 	}
          // }, timeout);
          // document.addEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e, timeout));
        } else {
          setTimeout(() => {
            liveConnect();
          }, 5000);
          emitter({
            name: "onConnectFailed",
            connectionState: LiveFeedHubConnection.state,
            response: error,
          });
          error &&
            window.log(
              "*******CONNECTION FAILED LIVE*******: ",
              error.toString()
            );
        }
      };

      LiveFeedHubConnection.onclose((error) => {
        emitter({
          name: "onDisconnect",
          connectionState: LiveFeedHubConnection && LiveFeedHubConnection.state,
          response: error,
        });
        error &&
          window.log("*******ON DISCONNECT LIVE*******: ", error.toString());
      });

      LiveFeedHubConnection.on("OnConnectionSlow", (data) => {
        emitter({
          name: "onConnectionSlow",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnError", (data) => {
        emitter({
          name: "onError",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnSportTypes", (data) => {
        emitter({
          name: "onSportTypes",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnWeekMatchDaysWeb", (data) => {
        emitter({
          name: "onWeekMatchDays",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnLiveDefaultSportType", (data) => {
        emitter({
          name: "onLiveDefaultSportType",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnMainTournamentEvents", (data) => {
        emitter({
          name: "onMainTournamentEvents",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnUpcomingDraws", (data) => {
        emitter({
          name: "onUpcomingDraws",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnDrawsCategoriesAndTournaments", (data) => {
        emitter({
          name: "onDrawsCategoriesAndTournaments",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnEventResult", (data) => {
        emitter({
          name: "onEventResult",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnDrawOdds", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnSuggestedBalls", (data) => {
        emitter({
          name: "onSuggestedBalls",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnSportCategories", (data) => {
        emitter({
          name: "onSportCategories",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnSportEvents", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnTopBets", (data) => {
        emitter({
          name: "onSportEvents",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnAllBetTypes", (data) => {
        emitter({
          name: "onAllBetTypes",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnSportEventsByDate", (data) => {
        emitter({
          name: "onSportEventsByDate",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnEventOddFieldData", (data) => {
        emitter({
          name: "onEventOddFieldData",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnJoinGroup", (data) => {
        emitter({
          name: "onJoinGroup",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnPartGroup", (data) => {
        emitter({
          name: "onPartGroup",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      // hubConnection.on("OnFeedChanges", data => {
      // 	emitter({
      // 		name: 'onFeedChanges',
      // 		connectionState: hubConnection.state,
      // 		response: Utils.inflate(data)
      // 	})
      // })

      LiveFeedHubConnection.on("OnSportEventsChange", (data) => {
        emitter({
          name: "onSportEventsChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnEventOddsChange", (data) => {
        emitter({
          name: "onEventOddsChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnEventOddGroupsChange", (data) => {
        emitter({
          name: "onEventOddGroupsChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      LiveFeedHubConnection.on("OnEventOddFieldsChange", (data) => {
        emitter({
          name: "onEventOddFieldsChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnEventScoreChange", (data) => {
        emitter({
          name: "onEventScoreChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnSportTournamentsChange", (data) => {
        emitter({
          name: "onSportTournamentsChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnTopBetTypesChange", (data) => {
        emitter({
          name: "onTopBetTypesChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnSportTypesChange", (data) => {
        emitter({
          name: "onSportTypesChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnSportCategoriesChange", (data) => {
        emitter({
          name: "onSportCategoriesChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnSportTopLeaguesChange", (data) => {
        emitter({
          name: "onSportTopLeaguesChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnUpcomingEventsChange", (data) => {
        emitter({
          name: "onUpcomingEventsChange",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnAllCacheData", (data) => {
        emitter({
          name: "onAllCacheData",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnSearchedData", (data) => {
        emitter({
          name: "onSearchedData",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnProducerDown", (data) => {
        emitter({
          name: "OnProducerDown",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnProducerUp", (data) => {
        emitter({
          name: "OnProducerUp",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnKironEventsList", (data) => {
        emitter({
          name: "OnKironEventsList",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      LiveFeedHubConnection.on("OnKironEvent", (data) => {
        emitter({
          name: "OnKironEvent",
          connectionState: LiveFeedHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      //Connect to hub
      liveConnect();

      // The subscriber must return an unsubscribe function
      return () => {
        LiveFeedHubConnection.stop();
        window.log("*******LiveFeedHubConnection.stop(); return*******: ");

        LiveFeedHubConnection = null;
        clearTimeout(connectInterval);
        //document.removeEventListener("click", (e) => handleSignalrExpiresOnClick(emitter, e));
      };
    });
  }

  function* registerJackpotChannel() {
    return eventChannel((emitter) => {
      document.addEventListener("click", (e) =>
        handleJPExpiresOnClick(emitter)
      );
      clearTimeout(jackpotSrTimeout);
      const timeoutExpires = AppConfig.JackpotSRTimeout * 60 * 1000;
      window.log(timeoutExpires);
      jackpotSrTimeout = setTimeout(() => {
        console.log("jackpot time out");
        emitter({ name: "OnJackpotTimeout" });
      }, timeoutExpires);

      if (!JackpotHubConnection) {
        JackpotHubConnection = new signalR.HubConnectionBuilder()
          .configureLogging(signalR.LogLevel.Information)
          .withUrl(AppConfig.jackpotSRAddress, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
          })
          //.withUrl(AppConfig.jackpotSRAddress, { skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
          .withAutomaticReconnect()
          .build();
        JackpotHubConnection.serverTimeoutInMilliseconds = 60000;
      }
      JackpotHubConnection.onreconnected((connectionId) => {
        window.log(
          "JACKPOT SIGNALR: client reconnected. connectionId ",
          connectionId
        );
        emitter({
          name: "onJackpotConnect",
          connectionState: JackpotHubConnection.state,
        });
        //Set no activity timout for 4.5 minutes
        clearTimeout(connectInterval);
      });

      JackpotHubConnection.onreconnecting((error) => {
        error &&
          window.log(
            `JACKPOT SIGNALR - client connect error ${error.toString()}, reconnecting... `
          );

        emitter({
          name: "onJackpotDisconnect",
          connectionState: JackpotHubConnection && JackpotHubConnection.state,
          response: error,
        });
      });

      JackpotHubConnection.onopen = (error) => {
        if (!error) {
          emitter({
            name: "onJackpotConnect",
            connectionState: JackpotHubConnection.state,
          });
        } else {
          setTimeout(() => {
            jackpotConnect();
          }, 5000);
          emitter({
            name: "onJackpotConnectFailed",
            connectionState: JackpotHubConnection.state,
            response: error,
          });
        }
      };

      JackpotHubConnection.onclose((error) => {
        emitter({
          name: "onJackpotDisconnect",
          connectionState: JackpotHubConnection && JackpotHubConnection.state,
          response: error,
        });
      });

      JackpotHubConnection.on("OnError", (data) => {
        emitter({
          name: "onError",
          connectionState: JackpotHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      JackpotHubConnection.on("OnJackpotWinning", (data) => {
        emitter({
          name: "onJackpotWinning",
          connectionState: JackpotHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      JackpotHubConnection.on("OnJackpotSingleGameWinning", (data) => {
        emitter({
          name: "onJackpotSingleGameWinning",
          connectionState: JackpotHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      JackpotHubConnection.on("OnJackpotBalance", (data) => {
        emitter({
          name: "onJackpotBalance",
          connectionState: JackpotHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      JackpotHubConnection.on("OnJackpotSingleGameBalance", (data) => {
        emitter({
          name: "onJackpotSingleGameBalance",
          connectionState: JackpotHubConnection.state,
          response: Utils.inflate(data),
        });
      });
      JackpotHubConnection.on("OnJackpotApproval", (data) => {
        emitter({
          name: "OnJackpotApproval",
          connectionState: JackpotHubConnection.state,
          response: Utils.inflate(data),
        });
      });

      //Connect to hub
      jackpotConnect();

      // The subscriber must return an unsubscribe function
      return () => {
        JackpotHubConnection.stop();
        JackpotHubConnection = null;
        clearTimeout(connectInterval);
        document.removeEventListener("click", jackpotListener);
      };
    });
  }

  function* registerMemberChangeChannel() {
    if (AppConfig.memberChangeSRAddress) {
      return eventChannel((emitter) => {
        if (!MemberChangeConnection) {
          MemberChangeConnection = new signalR.HubConnectionBuilder()
            .configureLogging(signalR.LogLevel.Information)
            //.withUrl(AppConfig.memberChangeSRAddress)
            .withUrl(AppConfig.memberChangeSRAddress, {
              skipNegotiation: true,
              transport: signalR.HttpTransportType.WebSockets,
            })
            .withAutomaticReconnect()
            .build();
          MemberChangeConnection.serverTimeoutInMilliseconds = 60000;
        }
        MemberChangeConnection.onreconnected((connectionId) => {
          console.log(
            "Member Change SIGNALR: client reconnected. connectionId ",
            connectionId
          );
          emitter({
            name: "onMemberChangeConnect",
            connectionState: MemberChangeConnection.state,
          });
          //Set no activity timout for 4.5 minutes
          clearTimeout(connectInterval);
        });

        MemberChangeConnection.onreconnecting((error) => {
          console.log("MemberChangeConnection.onreconnecting ");
          error &&
            console.log(
              `Member Change Signalr - client connect error ${error.toString()}, reconnecting... `
            );

          emitter({
            name: "onMemberChangeDisconnect",
            connectionState:
              MemberChangeConnection && MemberChangeConnection.state,
            response: error,
          });
        });

        MemberChangeConnection.onopen = (error) => {
          if (!error) {
            emitter({
              name: "onMemberChangeConnect",
              connectionState: MemberChangeConnection.state,
            });
          } else {
            setTimeout(() => {
              memberChangeConnect();
            }, 5000);
            emitter({
              name: "onMemberChangeConnectFailed",
              connectionState: MemberChangeConnection.state,
              response: error,
            });
          }
        };

        MemberChangeConnection.onclose((error) => {
          window.log("Member Change Signalr - disconnected  ");
          emitter({
            name: "onMemberChangeDisconnect",
            connectionState:
              MemberChangeConnection && MemberChangeConnection.state,
            response: error,
          });
        });

        MemberChangeConnection.on("OnError", (data) => {
          console.log("MemberChangeConnection.OnError ");
          emitter({
            name: "onError",
            connectionState: MemberChangeConnection.state,
            response: Utils.inflate(data),
          });
        });

        MemberChangeConnection.on("OnMemberDetails", (data) => {
          emitter({
            name: "OnMemberDetails",
            connectionState: MemberChangeConnection.state,
            response: Utils.inflate(data),
          });
        });

        //Connect to hub
        memberChangeConnect();

        // The subscriber must return an unsubscribe function
        return () => {
          MemberChangeConnection.stop();
          MemberChangeConnection = null;
        };
      });
    }
  }
  yield takeEvery(AppActionTypes.ChangeFeed, function*({ feedId }) {
    try {
      if (excludedRoutes.includes(window.location.pathname.toLowerCase())) {
        return;
      }
      window.log("SignalRTypes.ChangeFeed", feedId);

      let feed = parseInt(feedId);
      window.log("SignalRTypes.ChangeFeed after cast", feed);

      hubConnection = StaticFeedHubConnection;
      if (feed) {
        switch (feed) {
          case Enums.Feed.Static:
            hubConnection = StaticFeedHubConnection;
            break;
          case Enums.Feed.Slots:
            console.log("slots1");
            hubConnection = Cookies.get("token")
              ? BooongoHubConnection
              : StaticFeedHubConnection;
            break;
          case Enums.Feed.Live:
            hubConnection = LiveFeedHubConnection;
            break;
          case Enums.Feed.Casino:
          case Enums.Feed.SpinAndWin:
            hubConnection = SAWFeedHubConnection;
            break;
          case Enums.Feed.LuckyNumbers:
            hubConnection = LuckyNumbersFeedHubConnection;
            break;
          case Enums.Feed.EPL:
          case Enums.Feed.VBL:
          case Enums.Feed.VDR:
          case Enums.Feed.VFL:
          case Enums.Feed.VFLM:
          case Enums.Feed.VHC:
          case Enums.Feed.VTO:
            hubConnection = VirtualFeedHubConnection;
            break;
          default:
            hubConnection = JackpotHubConnection;
            break;
        }
      } else {
        hubConnection = StaticFeedHubConnection;
      }
      console.log("after change feed", hubConnection);
    } catch (e) {
      window.log("ERROR", e);
      yield put({ type: SignalRTypes.Connect_Error });
    }
  });
  // yield takeEvery(SignalRTypes.ChangeFeed, function* ({ feedId }) {
  //   try {
  //     window.log("SignalRTypes.ChangeFeed", feedId)

  //     let feed = parseInt(feedId);
  //     window.log("SignalRTypes.ChangeFeed after cast", feed)

  //     hubConnection = StaticFeedHubConnection;
  //     if (feed) {
  //       switch (feed) {
  //         case Enums.Feed.Static:
  //           hubConnection = StaticFeedHubConnection;
  //           break;
  //         case Enums.Feed.Slots:
  //           console.log("slots1")
  //           hubConnection = Cookies.get("token") ? BooongoHubConnection : StaticFeedHubConnection;
  //           break;
  //         case Enums.Feed.Live:
  //           hubConnection = LiveFeedHubConnection;
  //           break;
  //         case Enums.Feed.Casino:
  //         case Enums.Feed.SpinAndWin:
  //           hubConnection = SAWFeedHubConnection;
  //           break;
  //         case Enums.Feed.LuckyNumbers:

  //           hubConnection = LuckyNumbersFeedHubConnection;
  //           break;
  //         case Enums.Feed.EPL:
  //         case Enums.Feed.VBL:
  //         case Enums.Feed.VDR:
  //         case Enums.Feed.VFL:
  //         case Enums.Feed.VFLM:
  //         case Enums.Feed.VHC:
  //         case Enums.Feed.VTO:
  //           hubConnection = VirtualFeedHubConnection;
  //           break;
  //         default:
  //           hubConnection = JackpotHubConnection;
  //           break;
  //       }
  //     }
  //     else {
  //       hubConnection = StaticFeedHubConnection;
  //     }
  //     console.log("after change feed", hubConnection)

  //   } catch (e) {
  //     window.log("ERROR", e);
  //     yield put({ type: SignalRTypes.Connect_Error })

  //   }
  // })

  yield takeEvery(SignalRTypes.Connect_Request, function*() {
    try {
      if (chan) {
        chan.close();
      }
      // Prevent registering SignalR channel before setting the srAddress
      if (!AppConfig.srAddress) {
        return;
      }
      chan = yield call(registerSignalRChannel);

      while (true) {
        let event = yield take(chan);

        yield put({
          type: AppActionTypes.SetServerTime,
          serverTime: event.response && event.response.serverDateTime,
        });

        switch (event.name) {
          case "onConnect":
            yield put({
              type: SignalRTypes.Connect_Success,
            });
            break;

          case "onError":
            window.console.response("SignalR Error", event.response);
            break;

          case "onConnectFailed":
            yield put({
              type: SignalRTypes.Connect_Error,
              response: event.response,
            });
            break;
          case "onConnectionSlow":
            yield put({
              type: SignalRTypes.Connect_Slow,
              response: event.response,
            });
            break;

          case "onDisconnect":
            yield put({
              type: SignalRTypes.Disconnect_Success,
            });
            if (isActive) {
              setTimeout(() => {
                connect();
              }, 5000);
            }

            break;

          case "onSportTypes":
            yield put({
              type: SignalRTypes.SportTypes_Response,
              response: event.response,
            });
            break;
          case "onWeekMatchDays":
            yield put({
              type: SignalRTypes.By_Day_week_Days_response,
              response: event.response,
            });
            break;
          case "onLiveDefaultSportType":
            yield put({
              type: SignalRTypes.Default_Live_Sport_Type_Response,
              response: event.response,
            });
            break;
          case "onMainTournamentEvents":
            yield put({
              type: SignalRTypes.Main_Tournament_Events_Response,
              response: event.response,
            });
            break;
          case "onUpcomingDraws":
            yield put({
              type: SignalRTypes.OnUpcomingDrawsResponse,
              response: event.response,
            });
            break;
          case "onDrawsCategoriesAndTournaments":
            yield put({
              type: SignalRTypes.Get_Draws_Categories_And_Tournaments_Response,
              response: event.response,
            });
            break;
          case "onEventResult":
            yield put({
              type: SignalRTypes.Get_Lucky_Numbers_Event_Result_Response,
              response: event.response,
            });
            break;

          case "onSportCategories":
            yield put({
              type: SignalRTypes.SportCategories_Response,
              response: event.response,
            });
            break;

          case "onSportEvents":
            yield put({
              type: SignalRTypes.SportEvents_Response,
              response: event.response,
            });
            break;

          case "onAllBetTypes":
            yield put({
              type: SignalRTypes.AllBetTypes_Response,
              response: event.response,
            });
            break;
          case "onSuggestedBalls":
            yield put({
              type: SignalRTypes.Get_Suggested_Balls_Response,
              response: event.response,
            });
            break;

          case "onSportEventsByDate":
            yield put({
              type: SignalRTypes.SportEvents_Response,
              response: event.response,
            });
            break;
          case "onEventOddFieldData":
            yield put({
              type: SignalRTypes.Get_Updated_OddField_Details_Response,
              response: event.response,
            });
            break;

          case "onJoinGroup":
            yield put({
              type: SignalRTypes.Join_Response,
              response: event.response,
            });
            break;
          case "onPartGroup":
            yield put({
              type: SignalRTypes.Part_Response,
              response: event.response,
            });
            break;

          // case "onFeedChanges":
          // 	yield put({
          // 		type: SignalRTypes.OnFeedChanges,
          // 		response: event.response
          // 	})
          // 	break;

          ////////////////////////////
          case "onSportEventsChange":
            yield put({
              type: SignalRTypes.OnSportEventsChange,
              response: event.response,
            });
            break;
          case "onEventOddsChange":
            yield put({
              type: SignalRTypes.OnEventOddsChange,
              response: event.response,
            });
            break;
          case "onEventOddGroupsChange":
            yield put({
              type: SignalRTypes.onEventOddGroupsChange,
              response: event.response,
            });
            break;
          case "onEventOddFieldsChange":
            yield put({
              type: SignalRTypes.OnEventOddFieldsChange,
              response: event.response,
            });
            break;
          case "onEventScoreChange":
            yield put({
              type: SignalRTypes.OnEventScoreChange,
              response: event.response,
            });
            break;
          case "onSportTournamentsChange":
            yield put({
              type: SignalRTypes.OnSportTournamentsChange,
              response: event.response,
            });
            break;
          case "onTopBetTypesChange":
            yield put({
              type: SignalRTypes.OnTopBetTypesChange,
              response: event.response,
            });
            break;
          case "onSportTypesChange":
            yield put({
              type: SignalRTypes.OnSportTypesChange,
              response: event.response,
            });
            break;
          case "onSportCategoriesChange":
            yield put({
              type: SignalRTypes.OnSportCategoriesChange,
              response: event.response,
            });
            break;
          case "onSportTopLeaguesChange":
            yield put({
              type: SignalRTypes.OnSportTopLeaguesChange,
              response: event.response,
            });
            break;
          case "onUpcomingEventsChange":
            yield put({
              type: SignalRTypes.OnUpcomingEventsChange,
              response: event.response,
            });
            break;
          //////////////////////////////////////

          case "onTimer":
            yield put({
              type: SignalRTypes.OnTimer,
            });
            break;
          case "timeout":
            yield put({
              type: SignalRTypes.Disconnect_Request,
            });
            clearTimeout(connectInterval);
            break;
          case "reconnect":
            yield put({
              type: SignalRTypes.Re_Connect,
            });
            clearTimeout(connectInterval);
            break;

          case "onAllCacheData":
            yield put({
              type: SignalRTypes.GetAllData_Response,
              response: event.response,
            });
            break;
          case "onSearchedData":
            yield put({
              type: SearchActionTypes.GetSearchedData_Response,
              response: event.response,
            });
            break;
          case "OnProducerDown":
            yield put({
              type: SignalRTypes.Producer_Down,
              response: event.response.data,
            });

            window.log("*********Producer Down*************");

            break;
          case "OnProducerUp":
            yield put({
              type: SignalRTypes.Producer_Up,
              response: event.response.data,
            });

            window.log("*********Producer Up*************");

            break;
          case "OnKironEventsList":
            yield put({
              type: SignalRTypes.KironSportEvents_Response,
              response: event.response,
            });
            break;

          case "OnKironEvent":
            yield put({
              type: SignalRTypes.KironEvent_Response,
              response: event.response,
            });
            break;
        }
      }
    } catch (e) {
      window.log("ERROR", e);
      yield put({ type: SignalRTypes.Connect_Error });
    }
  });

  yield takeEvery(SignalRTypes.Static_Connect_Request, function*() {
    try {
      if (excludedRoutes.includes(window.location.pathname.toLowerCase())) {
        return;
      }
      if (staticChannel) {
        staticChannel.close();
      }
      if (!AppConfig.staticFeedSR) {
        yield put({ type: SignalRTypes.Static_Connect_Retry });
      } else {
        staticChannel = yield call(registerStaticFeedChangeChannel);

        while (true) {
          let event = yield take(staticChannel);
          yield put({
            type: AppActionTypes.SetServerTime,
            serverTime: event.response && event.response.serverDateTime,
          });

          switch (event.name) {
            case "onConnect":
              yield put({
                type: SignalRTypes.Static_Connect_Success,
              });
              window.log("*STATIC FEED CHANGE SIGNALR CONNECTION TRUE*");
              break;

            case "onError":
              window.console.response("SignalR Error", event.response);
              break;

            case "onConnectFailed":
              yield put({
                type: SignalRTypes.Static_Connect_Error,
                response: event.response,
              });

              break;
            case "onConnectionSlow":
              yield put({
                type: SignalRTypes.Static_Connect_Slow,
                response: event.response,
              });
              break;

            case "onDisconnect":
              const { signalr } = yield select();
              window.log(
                "static disconnected",
                signalr.staticDisconnectRequested
              );

              if (signalr.staticDisconnectRequested) {
                yield put({ type: SignalRTypes.Static_Disconnect_Success });
              } else {
                console.log("retry in 15000 static sr");
                setTimeout(() => {
                  staticConnect();
                }, 15000);
                yield put({ type: SignalRTypes.Static_Connect_Retry });
              }

              // yield put({
              // 	type: SignalRTypes.Static_Disconnect_Success,
              // })

              // if (isActive) {
              // 	setTimeout(() => { staticConnect() }, 5000);
              // }

              break;

            case "onSportTypes":
              yield put({
                type: SignalRTypes.SportTypes_Response,
                response: event.response,
              });
              break;
            case "onWeekMatchDays":
              yield put({
                type: SignalRTypes.By_Day_week_Days_response,
                response: event.response,
              });
              break;
            case "onLiveDefaultSportType":
              yield put({
                type: SignalRTypes.Default_Live_Sport_Type_Response,
                response: event.response,
              });
              break;
            case "onMainTournamentEvents":
              yield put({
                type: SignalRTypes.Main_Tournament_Events_Response,
                response: event.response,
              });
              break;
            case "onUpcomingDraws":
              yield put({
                type: SignalRTypes.OnUpcomingDrawsResponse,
                response: event.response,
              });
              break;
            case "onDrawsCategoriesAndTournaments":
              yield put({
                type:
                  SignalRTypes.Get_Draws_Categories_And_Tournaments_Response,
                response: event.response,
              });
              break;
            case "onEventResult":
              yield put({
                type: SignalRTypes.Get_Lucky_Numbers_Event_Result_Response,
                response: event.response,
              });
              break;

            case "onSportCategories":
              yield put({
                type: SignalRTypes.SportCategories_Response,
                response: event.response,
              });
              break;

            case "onSportEvents":
              yield put({
                type: SignalRTypes.SportEvents_Response,
                response: event.response,
              });
              break;

            case "onAllBetTypes":
              yield put({
                type: SignalRTypes.AllBetTypes_Response,
                response: event.response,
              });
              break;
            case "onSuggestedBalls":
              yield put({
                type: SignalRTypes.Get_Suggested_Balls_Response,
                response: event.response,
              });
              break;

            case "onSportEventsByDate":
              yield put({
                type: SignalRTypes.SportEvents_Response,
                response: event.response,
              });
              break;
            case "onEventOddFieldData":
              yield put({
                type: SignalRTypes.Get_Updated_OddField_Details_Response,
                response: event.response,
              });
              break;

            case "onJoinGroup":
              yield put({
                type: SignalRTypes.Join_Response,
                response: event.response,
              });
              break;
            case "onPartGroup":
              yield put({
                type: SignalRTypes.Part_Response,
                response: event.response,
              });
              break;

            // case "onFeedChanges":
            // 	yield put({
            // 		type: SignalRTypes.OnFeedChanges,
            // 		response: event.response
            // 	})
            // 	break;

            ////////////////////////////
            case "onSportEventsChange":
              yield put({
                type: SignalRTypes.OnSportEventsChange,
                response: event.response,
              });
              break;
            case "onEventOddsChange":
              yield put({
                type: SignalRTypes.OnEventOddsChange,
                response: event.response,
              });
              break;
            case "onEventOddGroupsChange":
              yield put({
                type: SignalRTypes.onEventOddGroupsChange,
                response: event.response,
              });
              break;
            case "onEventOddFieldsChange":
              yield put({
                type: SignalRTypes.OnEventOddFieldsChange,
                response: event.response,
              });
              break;
            case "onEventScoreChange":
              yield put({
                type: SignalRTypes.OnEventScoreChange,
                response: event.response,
              });
              break;
            case "onSportTournamentsChange":
              yield put({
                type: SignalRTypes.OnSportTournamentsChange,
                response: event.response,
              });
              break;
            case "onTopBetTypesChange":
              yield put({
                type: SignalRTypes.OnTopBetTypesChange,
                response: event.response,
              });
              break;
            case "onSportTypesChange":
              yield put({
                type: SignalRTypes.OnSportTypesChange,
                response: event.response,
              });
              break;
            case "onSportCategoriesChange":
              yield put({
                type: SignalRTypes.OnSportCategoriesChange,
                response: event.response,
              });
              break;
            case "onSportTopLeaguesChange":
              yield put({
                type: SignalRTypes.OnSportTopLeaguesChange,
                response: event.response,
              });
              break;
            case "onUpcomingEventsChange":
              yield put({
                type: SignalRTypes.OnUpcomingEventsChange,
                response: event.response,
              });
              break;
            //////////////////////////////////////

            case "onTimer":
              yield put({
                type: SignalRTypes.OnTimer,
              });
              break;
            case "timeout":
              yield put({
                type: SignalRTypes.Disconnect_Request,
              });
              clearTimeout(connectInterval);
              break;
            case "reconnect":
              yield put({
                type: SignalRTypes.Re_Connect,
              });
              clearTimeout(connectInterval);
              break;

            case "onAllCacheData":
              yield put({
                type: SignalRTypes.GetAllData_Response,
                response: event.response,
              });
              break;
            case "onSearchedData":
              yield put({
                type: SearchActionTypes.GetSearchedData_Response,
                response: event.response,
              });
              break;
            case "onCustomBetOddFieldData":
              yield put({
                type: SignalRTypes.Get_Custom_Bet_Odd_Field_Data_Success,
                response: event.response && event.response.data,
              });
              break;
            case "OnProducerDown":
              yield put({
                type: SignalRTypes.Producer_Down,
                response: event.response.data,
              });

              window.log("*********Producer Down*************");

              break;
            case "OnProducerUp":
              yield put({
                type: SignalRTypes.Producer_Up,
                response: event.response.data,
              });

              window.log("*********Producer Up*************");

              break;
            case "OnKironEventsList":
              yield put({
                type: SignalRTypes.KironSportEvents_Response,
                response: event.response,
              });
              break;

            case "OnKironEvent":
              yield put({
                type: SignalRTypes.KironEvent_Response,
                response: event.response,
              });
              break;
          }
        }
      }
    } catch (e) {
      window.log("ERROR", e);
      yield put({ type: SignalRTypes.Static_Connect_Error });
    }
  });

  yield takeEvery(SignalRTypes.Virtual_Connect_Request, function*() {
    try {
      // Add the paths you want to exclude

      if (excludedRoutes.includes(window.location.pathname.toLowerCase())) {
        return;
      }

      if (virtualChannel) {
        virtualChannel.close();
      }
      if (!AppConfig.virtualFeedSR) {
        yield put({ type: SignalRTypes.Virtual_Connect_Retry });
      } else {
        virtualChannel = yield call(registerVirtualFeedChangeChannel);

        while (true) {
          let event = yield take(virtualChannel);
          yield put({
            type: AppActionTypes.SetServerTime,
            serverTime: event.response && event.response.serverDateTime,
          });

          switch (event.name) {
            case "onConnect":
              yield put({
                type: SignalRTypes.Virtual_Connect_Success,
              });
              window.log("*VIRTUAL FEED CHANGE SIGNALR CONNECTION TRUE*");

              break;

            case "onError":
              window.console.response("SignalR Error", event.response);
              break;

            case "onConnectFailed":
              yield put({
                type: SignalRTypes.Virtual_Connect_Error,
                response: event.response,
              });

              break;
            case "onConnectionSlow":
              yield put({
                type: SignalRTypes.Virtual_Connect_Slow,
                response: event.response,
              });
              break;

            case "onDisconnect":
              const { signalr } = yield select();
              window.log(
                "virtual disconnected",
                signalr.virtualDisconnectRequested
              );

              if (signalr.virtualDisconnectRequested) {
                yield put({ type: SignalRTypes.Virtual_Disconnect_Success });
              } else {
                console.log("retry in 15000 virtual sr");
                setTimeout(() => {
                  virtualConnect();
                }, 15000);
                yield put({ type: SignalRTypes.Virtual_Connect_Retry });
              }

              // yield put({
              // 	type: SignalRTypes.Virtual_Disconnect_Success,
              // })

              // if (isActive) {
              // 	setTimeout(() => { virtualConnect() }, 5000);
              // }

              break;

            case "onSportTypes":
              yield put({
                type: SignalRTypes.SportTypes_Response,
                response: event.response,
              });
              break;
            case "onWeekMatchDays":
              yield put({
                type: SignalRTypes.By_Day_week_Days_response,
                response: event.response,
              });
              break;
            case "onLiveDefaultSportType":
              yield put({
                type: SignalRTypes.Default_Live_Sport_Type_Response,
                response: event.response,
              });
              break;
            case "onMainTournamentEvents":
              yield put({
                type: SignalRTypes.Main_Tournament_Events_Response,
                response: event.response,
              });
              break;
            case "onUpcomingDraws":
              yield put({
                type: SignalRTypes.OnUpcomingDrawsResponse,
                response: event.response,
              });
              break;
            case "onDrawsCategoriesAndTournaments":
              yield put({
                type:
                  SignalRTypes.Get_Draws_Categories_And_Tournaments_Response,
                response: event.response,
              });
              break;
            case "onEventResult":
              yield put({
                type: SignalRTypes.Get_Lucky_Numbers_Event_Result_Response,
                response: event.response,
              });
              break;

            case "onSportCategories":
              yield put({
                type: SignalRTypes.SportCategories_Response,
                response: event.response,
              });
              break;

            case "onSportEvents":
              yield put({
                type: SignalRTypes.SportEvents_Response,
                response: event.response,
              });
              break;

            case "onAllBetTypes":
              yield put({
                type: SignalRTypes.AllBetTypes_Response,
                response: event.response,
              });
              break;
            case "onSuggestedBalls":
              yield put({
                type: SignalRTypes.Get_Suggested_Balls_Response,
                response: event.response,
              });
              break;

            case "onSportEventsByDate":
              yield put({
                type: SignalRTypes.SportEvents_Response,
                response: event.response,
              });
              break;
            case "onEventOddFieldData":
              yield put({
                type: SignalRTypes.Get_Updated_OddField_Details_Response,
                response: event.response,
              });
              break;

            case "onJoinGroup":
              yield put({
                type: SignalRTypes.Join_Response,
                response: event.response,
              });
              break;
            case "onPartGroup":
              yield put({
                type: SignalRTypes.Part_Response,
                response: event.response,
              });
              break;

            // case "onFeedChanges":
            // 	yield put({
            // 		type: SignalRTypes.OnFeedChanges,
            // 		response: event.response
            // 	})
            // 	break;

            ////////////////////////////
            case "onSportEventsChange":
              yield put({
                type: SignalRTypes.OnSportEventsChange,
                response: event.response,
              });
              break;
            case "onEventOddsChange":
              yield put({
                type: SignalRTypes.OnEventOddsChange,
                response: event.response,
              });
              break;
            case "onEventOddGroupsChange":
              yield put({
                type: SignalRTypes.onEventOddGroupsChange,
                response: event.response,
              });
              break;
            case "onEventOddFieldsChange":
              yield put({
                type: SignalRTypes.OnEventOddFieldsChange,
                response: event.response,
              });
              break;
            case "onEventScoreChange":
              yield put({
                type: SignalRTypes.OnEventScoreChange,
                response: event.response,
              });
              break;
            case "onSportTournamentsChange":
              yield put({
                type: SignalRTypes.OnSportTournamentsChange,
                response: event.response,
              });
              break;
            case "onTopBetTypesChange":
              yield put({
                type: SignalRTypes.OnTopBetTypesChange,
                response: event.response,
              });
              break;
            case "onSportTypesChange":
              yield put({
                type: SignalRTypes.OnSportTypesChange,
                response: event.response,
              });
              break;
            case "onSportCategoriesChange":
              yield put({
                type: SignalRTypes.OnSportCategoriesChange,
                response: event.response,
              });
              break;
            case "onSportTopLeaguesChange":
              yield put({
                type: SignalRTypes.OnSportTopLeaguesChange,
                response: event.response,
              });
              break;
            case "onUpcomingEventsChange":
              yield put({
                type: SignalRTypes.OnUpcomingEventsChange,
                response: event.response,
              });
              break;
            //////////////////////////////////////

            case "onTimer":
              yield put({
                type: SignalRTypes.OnTimer,
              });
              break;
            case "timeout":
              yield put({
                type: SignalRTypes.Disconnect_Request,
              });
              clearTimeout(connectInterval);
              break;
            case "reconnect":
              yield put({
                type: SignalRTypes.Re_Connect,
              });
              clearTimeout(connectInterval);
              break;

            case "onAllCacheData":
              yield put({
                type: SignalRTypes.GetAllData_Response,
                response: event.response,
              });
              break;
            case "onSearchedData":
              yield put({
                type: SearchActionTypes.GetSearchedData_Response,
                response: event.response,
              });
              break;
            case "OnProducerDown":
              yield put({
                type: SignalRTypes.Producer_Down,
                response: event.response.data,
              });

              window.log("*********Producer Down*************");

              break;
            case "OnProducerUp":
              yield put({
                type: SignalRTypes.Producer_Up,
                response: event.response.data,
              });

              window.log("*********Producer Up*************");

              break;
            case "OnKironEventsList":
              yield put({
                type: SignalRTypes.KironSportEvents_Response,
                response: event.response,
              });
              break;

            case "OnKironEvent":
              yield put({
                type: SignalRTypes.KironEvent_Response,
                response: event.response,
              });
              break;
          }
        }
      }
    } catch (e) {
      window.log("ERROR", e);
      yield put({ type: SignalRTypes.Virtual_Connect_Error });
    }
  });

  yield takeEvery(SignalRTypes.Live_Connect_Request, function*() {
    try {
      if (excludedRoutes.includes(window.location.pathname.toLowerCase())) {
        return;
      }
      if (liveChannel) {
        liveChannel.close();
      }
      if (!AppConfig.liveFeedSR) {
        yield put({ type: SignalRTypes.Live_Connect_Retry });
      } else {
        liveChannel = yield call(registerLiveFeedChangeChannel);

        while (true) {
          let event = yield take(liveChannel);
          yield put({
            type: AppActionTypes.SetServerTime,
            serverTime: event.response && event.response.serverDateTime,
          });

          switch (event.name) {
            case "onConnect":
              yield put({
                type: SignalRTypes.Live_Connect_Success,
              });
              window.log("*LIVE FEED CHANGE SIGNALR CONNECTION TRUE*");

              break;

            case "onError":
              window.console.response("SignalR Error", event.response);
              break;

            case "onConnectFailed":
              yield put({
                type: SignalRTypes.Live_Connect_Error,
                response: event.response,
              });

              break;
            case "onConnectionSlow":
              yield put({
                type: SignalRTypes.Live_Connect_Slow,
                response: event.response,
              });
              break;

            case "onDisconnect":
              const { signalr } = yield select();
              window.log("live disconnected", signalr.liveDisconnectRequested);

              if (signalr.liveDisconnectRequested) {
                yield put({ type: SignalRTypes.Live_Disconnect_Success });
              } else {
                console.log("retry in 15000 live sr");
                setTimeout(() => {
                  liveConnect();
                }, 15000);
                yield put({ type: SignalRTypes.Live_Connect_Retry });
              }

              // yield put({
              // 	type: SignalRTypes.Static_Disconnect_Success,
              // })

              // if (isActive) {
              // 	setTimeout(() => { staticConnect() }, 5000);
              // }

              break;

            case "onSportTypes":
              yield put({
                type: SignalRTypes.SportTypes_Response,
                response: event.response,
              });
              break;
            case "onWeekMatchDays":
              yield put({
                type: SignalRTypes.By_Day_week_Days_response,
                response: event.response,
              });
              break;
            case "onLiveDefaultSportType":
              yield put({
                type: SignalRTypes.Default_Live_Sport_Type_Response,
                response: event.response,
              });
              break;
            case "onMainTournamentEvents":
              yield put({
                type: SignalRTypes.Main_Tournament_Events_Response,
                response: event.response,
              });
              break;
            case "onUpcomingDraws":
              yield put({
                type: SignalRTypes.OnUpcomingDrawsResponse,
                response: event.response,
              });
              break;
            case "onDrawsCategoriesAndTournaments":
              yield put({
                type:
                  SignalRTypes.Get_Draws_Categories_And_Tournaments_Response,
                response: event.response,
              });
              break;
            case "onEventResult":
              yield put({
                type: SignalRTypes.Get_Lucky_Numbers_Event_Result_Response,
                response: event.response,
              });
              break;

            case "onSportCategories":
              yield put({
                type: SignalRTypes.SportCategories_Response,
                response: event.response,
              });
              break;

            case "onSportEvents":
              yield put({
                type: SignalRTypes.SportEvents_Response,
                response: event.response,
              });
              break;

            case "onAllBetTypes":
              yield put({
                type: SignalRTypes.AllBetTypes_Response,
                response: event.response,
              });
              break;
            case "onSuggestedBalls":
              yield put({
                type: SignalRTypes.Get_Suggested_Balls_Response,
                response: event.response,
              });
              break;

            case "onSportEventsByDate":
              yield put({
                type: SignalRTypes.SportEvents_Response,
                response: event.response,
              });
              break;
            case "onEventOddFieldData":
              yield put({
                type: SignalRTypes.Get_Updated_OddField_Details_Response,
                response: event.response,
              });
              break;

            case "onJoinGroup":
              yield put({
                type: SignalRTypes.Join_Response,
                response: event.response,
              });
              break;
            case "onPartGroup":
              yield put({
                type: SignalRTypes.Part_Response,
                response: event.response,
              });
              break;

            // case "onFeedChanges":
            // 	yield put({
            // 		type: SignalRTypes.OnFeedChanges,
            // 		response: event.response
            // 	})
            // 	break;

            ////////////////////////////
            case "onSportEventsChange":
              yield put({
                type: SignalRTypes.OnSportEventsChange,
                response: event.response,
              });
              break;
            case "onEventOddsChange":
              yield put({
                type: SignalRTypes.OnEventOddsChange,
                response: event.response,
              });
              break;
            case "onEventOddGroupsChange":
              yield put({
                type: SignalRTypes.onEventOddGroupsChange,
                response: event.response,
              });
              break;
            case "onEventOddFieldsChange":
              yield put({
                type: SignalRTypes.OnEventOddFieldsChange,
                response: event.response,
              });
              break;
            case "onEventScoreChange":
              yield put({
                type: SignalRTypes.OnEventScoreChange,
                response: event.response,
              });
              break;
            case "onSportTournamentsChange":
              yield put({
                type: SignalRTypes.OnSportTournamentsChange,
                response: event.response,
              });
              break;
            case "onTopBetTypesChange":
              yield put({
                type: SignalRTypes.OnTopBetTypesChange,
                response: event.response,
              });
              break;
            case "onSportTypesChange":
              yield put({
                type: SignalRTypes.OnSportTypesChange,
                response: event.response,
              });
              break;
            case "onSportCategoriesChange":
              yield put({
                type: SignalRTypes.OnSportCategoriesChange,
                response: event.response,
              });
              break;
            case "onSportTopLeaguesChange":
              yield put({
                type: SignalRTypes.OnSportTopLeaguesChange,
                response: event.response,
              });
              break;
            case "onUpcomingEventsChange":
              yield put({
                type: SignalRTypes.OnUpcomingEventsChange,
                response: event.response,
              });
              break;
            //////////////////////////////////////

            case "onTimer":
              yield put({
                type: SignalRTypes.OnTimer,
              });
              break;
            case "timeout":
              yield put({
                type: SignalRTypes.Disconnect_Request,
              });
              clearTimeout(connectInterval);
              break;
            case "reconnect":
              yield put({
                type: SignalRTypes.Re_Connect,
              });
              clearTimeout(connectInterval);
              break;

            case "onAllCacheData":
              yield put({
                type: SignalRTypes.GetAllData_Response,
                response: event.response,
              });
              break;
            case "onSearchedData":
              yield put({
                type: SearchActionTypes.GetSearchedData_Response,
                response: event.response,
              });
              break;
            case "OnProducerDown":
              yield put({
                type: SignalRTypes.Producer_Down,
                response: event.response.data,
              });

              window.log("*********Producer Down*************");

              break;
            case "OnProducerUp":
              yield put({
                type: SignalRTypes.Producer_Up,
                response: event.response.data,
              });

              window.log("*********Producer Up*************");

              break;
            case "OnKironEventsList":
              yield put({
                type: SignalRTypes.KironSportEvents_Response,
                response: event.response,
              });
              break;

            case "OnKironEvent":
              yield put({
                type: SignalRTypes.KironEvent_Response,
                response: event.response,
              });
              break;
          }
        }
      }
    } catch (e) {
      window.log("ERROR", e);
      yield put({ type: SignalRTypes.Live_Connect_Error });
    }
  });

  yield takeEvery(SignalRTypes.SpinAndWin_Connect_Request, function*() {
    try {
      if (excludedRoutes.includes(window.location.pathname.toLowerCase())) {
        return;
      }
      if (spinAndWinChannel) {
        spinAndWinChannel.close();
      }
      const { signalr } = yield select();
      if (signalr.spinAndWinDisconnectRequested) return;
      if (!AppConfig.spinAndWinFeedSR) {
        yield put({ type: SignalRTypes.SpinAndWin_Connect_Retry });
      } else {
        spinAndWinChannel = yield call(registerSpinAndWinFeedChangeChannel);

        while (true) {
          let event = yield take(spinAndWinChannel);
          yield put({
            type: AppActionTypes.SetServerTime,
            serverTime: event.response && event.response.serverDateTime,
          });

          switch (event.name) {
            case "onConnect":
              yield put({
                type: SignalRTypes.SpinAndWin_Connect_Success,
              });
              window.log("*SPIN AND WIN FEED CHANGE SIGNALR CONNECTION TRUE*");

              break;

            case "onError":
              window.console.response("SignalR Error", event.response);
              break;

            case "onConnectFailed":
              yield put({
                type: SignalRTypes.SpinAndWin_Connect_Error,
                response: event.response,
              });

              break;
            case "onConnectionSlow":
              yield put({
                type: SignalRTypes.SpinAndWin_Connect_Slow,
                response: event.response,
              });
              break;

            case "onDisconnect":
              const { signalr } = yield select();
              window.log(
                "spin and win disconnected",
                signalr.spinAndWinDisconnectRequested
              );

              if (signalr.spinAndWinDisconnectRequested) {
                yield put({ type: SignalRTypes.SpinAndWin_Disconnect_Success });
              } else {
                console.log("retry in 15000 spin and win sr");
                setTimeout(() => {
                  spinAndWinConnect();
                }, 15000);
                yield put({ type: SignalRTypes.SpinAndWin_Connect_Retry });
              }

              // yield put({
              // 	type: SignalRTypes.Static_Disconnect_Success,
              // })

              // if (isActive) {
              // 	setTimeout(() => { staticConnect() }, 5000);
              // }

              break;

            case "onSportTypes":
              yield put({
                type: SignalRTypes.SportTypes_Response,
                response: event.response,
              });
              break;
            case "onWeekMatchDays":
              yield put({
                type: SignalRTypes.By_Day_week_Days_response,
                response: event.response,
              });
              break;
            case "onLiveDefaultSportType":
              yield put({
                type: SignalRTypes.Default_Live_Sport_Type_Response,
                response: event.response,
              });
              break;
            case "onMainTournamentEvents":
              yield put({
                type: SignalRTypes.Main_Tournament_Events_Response,
                response: event.response,
              });
              break;
            case "onUpcomingDraws":
              yield put({
                type: SignalRTypes.OnUpcomingDrawsResponse,
                response: event.response,
              });
              break;
            case "onDrawsCategoriesAndTournaments":
              yield put({
                type:
                  SignalRTypes.Get_Draws_Categories_And_Tournaments_Response,
                response: event.response,
              });
              break;
            case "onEventResult":
              yield put({
                type: SignalRTypes.Get_Lucky_Numbers_Event_Result_Response,
                response: event.response,
              });
              break;

            case "onSportCategories":
              yield put({
                type: SignalRTypes.SportCategories_Response,
                response: event.response,
              });
              break;

            case "onSportEvents":
              yield put({
                type: SignalRTypes.SportEvents_Response,
                response: event.response,
              });
              break;

            case "onAllBetTypes":
              yield put({
                type: SignalRTypes.AllBetTypes_Response,
                response: event.response,
              });
              break;
            case "onSuggestedBalls":
              yield put({
                type: SignalRTypes.Get_Suggested_Balls_Response,
                response: event.response,
              });
              break;

            case "onSportEventsByDate":
              yield put({
                type: SignalRTypes.SportEvents_Response,
                response: event.response,
              });
              break;
            case "onEventOddFieldData":
              yield put({
                type: SignalRTypes.Get_Updated_OddField_Details_Response,
                response: event.response,
              });
              break;

            case "onJoinGroup":
              yield put({
                type: SignalRTypes.Join_Response,
                response: event.response,
              });
              break;
            case "onPartGroup":
              yield put({
                type: SignalRTypes.Part_Response,
                response: event.response,
              });
              break;

            // case "onFeedChanges":
            // 	yield put({
            // 		type: SignalRTypes.OnFeedChanges,
            // 		response: event.response
            // 	})
            // 	break;

            ////////////////////////////
            case "onSportEventsChange":
              yield put({
                type: SignalRTypes.OnSportEventsChange,
                response: event.response,
              });
              break;
            case "onEventOddsChange":
              yield put({
                type: SignalRTypes.OnEventOddsChange,
                response: event.response,
              });
              break;
            case "onEventOddGroupsChange":
              yield put({
                type: SignalRTypes.onEventOddGroupsChange,
                response: event.response,
              });
              break;
            case "onEventOddFieldsChange":
              yield put({
                type: SignalRTypes.OnEventOddFieldsChange,
                response: event.response,
              });
              break;
            case "onEventScoreChange":
              yield put({
                type: SignalRTypes.OnEventScoreChange,
                response: event.response,
              });
              break;
            case "onSportTournamentsChange":
              yield put({
                type: SignalRTypes.OnSportTournamentsChange,
                response: event.response,
              });
              break;
            case "onTopBetTypesChange":
              yield put({
                type: SignalRTypes.OnTopBetTypesChange,
                response: event.response,
              });
              break;
            case "onSportTypesChange":
              yield put({
                type: SignalRTypes.OnSportTypesChange,
                response: event.response,
              });
              break;
            case "onSportCategoriesChange":
              yield put({
                type: SignalRTypes.OnSportCategoriesChange,
                response: event.response,
              });
              break;
            case "onSportTopLeaguesChange":
              yield put({
                type: SignalRTypes.OnSportTopLeaguesChange,
                response: event.response,
              });
              break;
            case "onUpcomingEventsChange":
              yield put({
                type: SignalRTypes.OnUpcomingEventsChange,
                response: event.response,
              });
              break;
            //////////////////////////////////////

            case "onTimer":
              yield put({
                type: SignalRTypes.OnTimer,
              });
              break;
            case "timeout":
              yield put({
                type: SignalRTypes.Disconnect_Request,
              });
              clearTimeout(connectInterval);
              break;
            case "reconnect":
              yield put({
                type: SignalRTypes.Re_Connect,
              });
              clearTimeout(connectInterval);
              break;

            case "onAllCacheData":
              yield put({
                type: SignalRTypes.GetAllData_Response,
                response: event.response,
              });
              break;
            case "onSearchedData":
              yield put({
                type: SearchActionTypes.GetSearchedData_Response,
                response: event.response,
              });
              break;
            case "OnProducerDown":
              yield put({
                type: SignalRTypes.Producer_Down,
                response: event.response.data,
              });

              window.log("*********Producer Down*************");

              break;
            case "OnProducerUp":
              yield put({
                type: SignalRTypes.Producer_Up,
                response: event.response.data,
              });

              window.log("*********Producer Up*************");

              break;
            case "OnKironEventsList":
              yield put({
                type: SignalRTypes.KironSportEvents_Response,
                response: event.response,
              });
              break;

            case "OnKironEvent":
              yield put({
                type: SignalRTypes.KironEvent_Response,
                response: event.response,
              });
              break;
          }
        }
      }
    } catch (e) {
      window.log("ERROR", e);
      yield put({ type: SignalRTypes.SpinAndWin_Connect_Error });
    }
  });

  yield takeEvery(SignalRTypes.LuckyNumbers_Connect_Request, function*() {
    try {
      if (excludedRoutes.includes(window.location.pathname.toLowerCase())) {
        return;
      }
      if (luckyNumbersChannel) {
        luckyNumbersChannel.close();
      }
      const { signalr } = yield select();
      if (signalr.luckyNumbersDisconnectRequested) return;
      window.log("AppConfig.luckyNumbersFeedSR", AppConfig.luckyNumbersFeedSR);
      if (!AppConfig.luckyNumbersFeedSR) {
        yield put({ type: SignalRTypes.LuckyNumbers_Connect_Retry });
      } else {
        luckyNumbersChannel = yield call(registerLuckyNumbersFeedChangeChannel);

        while (true) {
          let event = yield take(luckyNumbersChannel);
          yield put({
            type: AppActionTypes.SetServerTime,
            serverTime: event.response && event.response.serverDateTime,
          });

          switch (event.name) {
            case "onConnect":
              yield put({
                type: SignalRTypes.LuckyNumbers_Connect_Success,
              });

              window.log("*LUCKY NUMBERS FEED CHANGE SIGNALR CONNECTION TRUE*");

              break;

            case "onError":
              window.console.response("SignalR Error", event.response);
              break;

            case "onConnectFailed":
              yield put({
                type: SignalRTypes.LuckyNumbers_Connect_Error,
                response: event.response,
              });

              break;
            case "onConnectionSlow":
              yield put({
                type: SignalRTypes.LuckyNumbers_Connect_Slow,
                response: event.response,
              });
              break;

            case "onDisconnect":
              const { signalr } = yield select();
              window.log(
                "lucky numbers disconnected",
                signalr.luckyNumbersDisconnectRequested
              );

              if (signalr.luckyNumbersDisconnectRequested) {
                yield put({
                  type: SignalRTypes.LuckyNumbers_Disconnect_Success,
                });
              } else {
                console.log("retry in 150w00 lucky number win sr");
                setTimeout(() => {
                  luckyNumberConnect();
                }, 15000);
                yield put({ type: SignalRTypes.LuckyNumbers_Connect_Retry });
              }

              // yield put({
              // 	type: SignalRTypes.LuckyNumbers_Disconnect_Success,
              // })

              // if (isActive) {
              // 	setTimeout(() => { staticConnect() }, 5000);
              // }

              break;

            case "onSportTypes":
              yield put({
                type: SignalRTypes.SportTypes_Response,
                response: event.response,
              });
              break;
            case "onWeekMatchDays":
              yield put({
                type: SignalRTypes.By_Day_week_Days_response,
                response: event.response,
              });
              break;
            case "onLiveDefaultSportType":
              yield put({
                type: SignalRTypes.Default_Live_Sport_Type_Response,
                response: event.response,
              });
              break;
            case "onMainTournamentEvents":
              yield put({
                type: SignalRTypes.Main_Tournament_Events_Response,
                response: event.response,
              });
              break;
            case "onUpcomingDraws":
              yield put({
                type: SignalRTypes.OnUpcomingDrawsResponse,
                response: event.response,
              });
              break;
            case "onDrawsCategoriesAndTournaments":
              yield put({
                type:
                  SignalRTypes.Get_Draws_Categories_And_Tournaments_Response,
                response: event.response,
              });
              break;
            case "onEventResult":
              yield put({
                type: SignalRTypes.Get_Lucky_Numbers_Event_Result_Response,
                response: event.response,
              });
              break;

            case "onSportCategories":
              yield put({
                type: SignalRTypes.SportCategories_Response,
                response: event.response,
              });
              break;

            case "onSportEvents":
              yield put({
                type: SignalRTypes.SportEvents_Response,
                response: event.response,
              });
              break;

            case "onAllBetTypes":
              yield put({
                type: SignalRTypes.AllBetTypes_Response,
                response: event.response,
              });
              break;
            case "onSuggestedBalls":
              yield put({
                type: SignalRTypes.Get_Suggested_Balls_Response,
                response: event.response,
              });
              break;

            case "onSportEventsByDate":
              yield put({
                type: SignalRTypes.SportEvents_Response,
                response: event.response,
              });
              break;
            case "onEventOddFieldData":
              yield put({
                type: SignalRTypes.Get_Updated_OddField_Details_Response,
                response: event.response,
              });
              break;

            case "onJoinGroup":
              yield put({
                type: SignalRTypes.Join_Response,
                response: event.response,
              });
              break;
            case "onPartGroup":
              yield put({
                type: SignalRTypes.Part_Response,
                response: event.response,
              });
              break;

            // case "onFeedChanges":
            // 	yield put({
            // 		type: SignalRTypes.OnFeedChanges,
            // 		response: event.response
            // 	})
            // 	break;

            ////////////////////////////
            case "onSportEventsChange":
              yield put({
                type: SignalRTypes.OnSportEventsChange,
                response: event.response,
              });
              break;
            case "onEventOddsChange":
              yield put({
                type: SignalRTypes.OnEventOddsChange,
                response: event.response,
              });
              break;
            case "onEventOddGroupsChange":
              yield put({
                type: SignalRTypes.onEventOddGroupsChange,
                response: event.response,
              });
              break;
            case "onEventOddFieldsChange":
              yield put({
                type: SignalRTypes.OnEventOddFieldsChange,
                response: event.response,
              });
              break;
            case "onEventScoreChange":
              yield put({
                type: SignalRTypes.OnEventScoreChange,
                response: event.response,
              });
              break;
            case "onSportTournamentsChange":
              yield put({
                type: SignalRTypes.OnSportTournamentsChange,
                response: event.response,
              });
              break;
            case "onTopBetTypesChange":
              yield put({
                type: SignalRTypes.OnTopBetTypesChange,
                response: event.response,
              });
              break;
            case "onSportTypesChange":
              yield put({
                type: SignalRTypes.OnSportTypesChange,
                response: event.response,
              });
              break;
            case "onSportCategoriesChange":
              yield put({
                type: SignalRTypes.OnSportCategoriesChange,
                response: event.response,
              });
              break;
            case "onSportTopLeaguesChange":
              yield put({
                type: SignalRTypes.OnSportTopLeaguesChange,
                response: event.response,
              });
              break;
            case "onUpcomingEventsChange":
              yield put({
                type: SignalRTypes.OnUpcomingEventsChange,
                response: event.response,
              });
              break;
            //////////////////////////////////////

            case "onTimer":
              yield put({
                type: SignalRTypes.OnTimer,
              });
              break;
            case "timeout":
              yield put({
                type: SignalRTypes.Disconnect_Request,
              });
              clearTimeout(connectInterval);
              break;
            case "reconnect":
              yield put({
                type: SignalRTypes.Re_Connect,
              });
              clearTimeout(connectInterval);
              break;

            case "onAllCacheData":
              yield put({
                type: SignalRTypes.GetAllData_Response,
                response: event.response,
              });
              break;
            case "onSearchedData":
              yield put({
                type: SearchActionTypes.GetSearchedData_Response,
                response: event.response,
              });
              break;
            case "OnProducerDown":
              yield put({
                type: SignalRTypes.Producer_Down,
                response: event.response.data,
              });

              window.log("*********Producer Down*************");

              break;
            case "OnProducerUp":
              yield put({
                type: SignalRTypes.Producer_Up,
                response: event.response.data,
              });

              window.log("*********Producer Up*************");

              break;
            case "OnKironEventsList":
              yield put({
                type: SignalRTypes.KironSportEvents_Response,
                response: event.response,
              });
              break;

            case "OnKironEvent":
              yield put({
                type: SignalRTypes.KironEvent_Response,
                response: event.response,
              });
              break;
          }
        }
      }
    } catch (e) {
      window.log("ERROR", e);
      yield put({ type: SignalRTypes.LuckyNumbers_Connect_Error });
    }
  });

  yield takeEvery(SignalRTypes.Connect_to_Banner_Hub, function*() {
    try {
      if (kioskChan) {
        kioskChan.close();
      }
      kioskChan = yield call(registerKioskBannerChannel);

      while (true) {
        let event = yield take(kioskChan);
        switch (event.name) {
          case "onConnectBannerHub":
            yield put({
              type: SignalRTypes.Connect_to_Banner_Hub_Success,
              kioskBannersConnection: true,
            });
            break;
          case "onReconnectBannerHub":
            yield put({
              type: SignalRTypes.Connect_to_Banner_Hub_Success,
              kioskBannersConnection: false,
            });
            break;
          case "onCurrentBanner":
            yield put({
              type: SignalRTypes.On_Current_Banner_Response,
              response: event.response,
            });
            break;
          case "onBannerChange":
            yield put({
              type: SignalRTypes.On_Banner_Change,
              response: event.response,
            });
            break;
          case "onConfigrationChange":
            yield put({
              type: SignalRTypes.On_Configration_Change,
              response: event.response,
            });
            break;
          case "onJoinGroup":
            yield put({
              type: SignalRTypes.Join_Response,
              response: event.response,
            });
            break;
        }
      }
    } catch (e) {
      window.log("ERROR in Banner Hub", e);
    }
  });

  yield takeEvery(SignalRTypes.Get_Current_Banner_Request, function*({
    bannerGroupId,
    GroupId,
  }) {
    try {
      //  to get the current banner

      console.log("to get the current banner");
      if (
        kioskBannerHubConnection &&
        kioskBannerHubConnection.state === signalR.HubConnectionState.Connected
      ) {
        console.log(
          "Sending bannerGroupId to GetCurrentBanner:",
          bannerGroupId
        );
        console.log(`Join Group BannerKioskId${GroupId}`);
        yield kioskBannerHubConnection.send(
          "JoinGroup",
          `BannerKioskId${GroupId}`
        );
        yield kioskBannerHubConnection.send(
          "GetCurrentBanner",
          Number(bannerGroupId)
        );
      } else {
        // Handle the case when the connection is not in the Connected state
        console.log("Hub connection is not in the Connected state.");
      }
    } catch (e) {
      window.log("ERROR in Get_Current_Banner_Request", e);
    }
  });

  yield takeEvery(
    SignalRTypes.Get_Custom_Bet_Odd_Field_Data_Request,
    function*({ request }) {
      try {
        //  to get the current banner
        window.console.request("REQ Custom Bet Data:", request);
        yield StaticFeedHubConnection.send("GetCustomBetOddFieldData", request);
      } catch (e) {
        window.log("ERROR in Get_Custom_Bet_Odd_Field_Data_Request", e);
      }
    }
  );

  yield takeEvery(SignalRTypes.Booongo_Connect_Request, function*() {
    try {
      if (booongoChannel) {
        booongoChannel.close();
      }
      booongoChannel = yield call(registerBooongoChannel);

      while (true) {
        let event = yield take(booongoChannel);

        switch (event.name) {
          case "onBooongoConnect":
            yield put({
              type: SignalRTypes.Booongo_Connect_Success,
            });
            window.log("*BOOONGO SIGNALR CONNECTION TRUE*");
            break;

          case "onError":
            window.console.response("Booongo Error", event.response);
            break;

          case "onBooongoConnectFailed":
            yield put({
              type: SignalRTypes.Booongo_Connect_Error,
              response: event.response,
            });
            break;

          case "onBooongoDisconnect":
            yield put({
              type: SignalRTypes.Booongo_Disconnect_Success,
            });
            setTimeout(() => {
              booongoConnect();
            }, 5000);
            break;

          case "onEntityBalances":
            yield put({
              type: SignalRTypes.Update_Entity_Balance,
              response: event.response,
            });
            break;
        }
      }
    } catch (e) {
      window.log("ERROR", e);
      yield put({ type: SignalRTypes.Booongo_Connect_Error });
    }
  });

  yield takeEvery(SignalRTypes.Member_Change_Connect_Request, function*() {
    try {
      if (memberChangeChannel) {
        memberChangeChannel.close();
      }
      memberChangeChannel = yield call(registerMemberChangeChannel);

      while (true) {
        let event = yield take(memberChangeChannel);

        switch (event.name) {
          case "onMemberChangeConnect":
            yield put({
              type: SignalRTypes.Member_Change_Connect_Success,
            });
            window.log("*MEMBER CHANGE SIGNALR CONNECTION TRUE*");
            break;

          case "onError":
            window.console.response("Member Change Error", event.response);
            break;

          case "onMemberChangeConnectFailed":
            yield put({
              type: SignalRTypes.Member_Change_Connect_Error,
              response: event.response,
            });
            break;

          case "onMemberChangeDisconnect":
            yield put({
              type: SignalRTypes.Member_Change_Disconnect_Success,
            });
            setTimeout(() => {
              memberChangeConnect();
            }, 5000);
            break;

          case "OnMemberDetails":
            let balance = 0;
            yield event.response.data.memberBalnaceChanged.map((item) => {
              let user = Cookies.get("user");
              let selectedCurrency = Cookies.get("selectedCurrency");
              if (user) {
                let balances = user.balance;
                Object.values(balances).map((balance, index) => {
                  if (balance.currencyId === item.currencyId) {
                    balance.balance = item.totalBalance;
                    balance.balanceValueStatus = item.balanceValueStatus;
                  }
                });

                user.balance = balances;
                Cookies.set("user", user);
                let currentCurrency = Object.keys(balances).find((balance) => {
                  return (
                    balances[balance].currencySymbol ===
                    selectedCurrency.currencySymbol
                  );
                });
                Cookies.set("selectedCurrency", balances[currentCurrency]);
                //balances[0] && balances[0][currentCurrency] &&
                //console.response("member balance change",balances, balances[1])
                console.response(
                  "member balance change",
                  balances,
                  balances[currentCurrency].balance,
                  balances[currentCurrency].balanceValueStatus
                );
                balance = balances[currentCurrency].balance;

                return put({
                  type: SignalRTypes.Member_Change_Update_Balance,
                  balance: balances[currentCurrency].balance,
                  balanceStatus: balances[currentCurrency].balanceValueStatus,
                });
              }
            });
            yield delay(3000);
            yield put({
              type: SignalRTypes.Member_Change_Update_Balance,
              balance: balance,
              balanceStatus: 0,
            });
            break;
        }
      }
    } catch (e) {
      window.log("ERROR", e);
      yield put({ type: SignalRTypes.Member_Change_Connect_Error });
    }
  });

  yield takeEvery(SignalRTypes.Jackpot_Connect_Request, function*() {
    try {
      if (!AppConfig.jackpotSRAddress) {
        yield put({ type: SignalRTypes.Jackpot_Connect_Retry });
      } else {
        if (jackpotChannel) {
          jackpotChannel.close();
        }
        jackpotChannel = yield call(registerJackpotChannel);

        while (true) {
          let event = yield take(jackpotChannel);

          switch (event.name) {
            case "onJackpotConnect":
              yield put({
                type: SignalRTypes.Jackpot_Connect_Success,
              });
              break;

            case "onError":
              window.console.response("Jackpot Error", event.response);
              break;

            case "onJackpotConnectFailed":
              yield put({
                type: SignalRTypes.Jackpot_Connect_Error,
                response: event.response,
              });
              break;

            case "onJackpotDisconnect":
              yield put({
                type: SignalRTypes.Jackpot_Disconnect_Success,
              });
              //setTimeout(() => { jackpotConnect() }, 5000);
              break;

            case "onJackpotWinning":
              yield put({
                type: SignalRTypes.Jackpot_Winning_Update,
                response: event.response,
              });
              break;
            case "onJackpotSingleGameWinning":
              yield put({
                type: SignalRTypes.Jackpot_Winning_Update,
                response: event.response,
              });
              break;
            case "onJackpotBalance":
              yield put({
                type: SignalRTypes.Jackpot_Balance_Update,
                response: event.response,
              });
              break;
            case "onJackpotSingleGameBalance":
              yield put({
                type: SignalRTypes.Jackpot_Balance_Update,
                response: event.response,
              });
              break;
            case "OnJackpotApproval":
              yield put({
                type: SignalRTypes.Jackpot_Approval_Update_Request,
                response: event.response,
              });
              break;
            case "OnJackpotTimeout":
              console.log("OnJackpotTimeout Jackpot_Disconnect_Request");
              yield put({
                type: SignalRTypes.Jackpot_Disconnect_Request,
              });
              break;
            case "JackpotReconnect":
              console.log("JackpotReconnect Jackpot_Connect_Request");
              yield put({
                type: SignalRTypes.Jackpot_Connect_Request,
              });
              break;
          }
        }
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  //******************** Member Change hub functions *********************//
  yield takeEvery(SignalRTypes.Member_Change_Connect_Success, function*() {
    try {
      const token = Cookies.get("token");
      if (token) {
        //const memberId = Cookies.get("memberId");
        window.log(`joined: MDT${token}`);
        yield MemberChangeConnection.send("JoinGroup", `MDT${token}`);
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Member_Change_Disconnect_Request, function*() {
    try {
      MemberChangeConnection.stop();
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  //******************** Booongo hub functions *********************//
  yield takeEvery(SignalRTypes.Booongo_Connect_Success, function*() {
    try {
      window.log("booongo connect success");
      if (Cookies.get("token")) {
        const memberId = Cookies.get("memberId");
        window.log(`T2ID${memberId}`);
        yield BooongoHubConnection.send("JoinGroup", `T2ID${memberId}`);
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Booongo_Disconnect_Request, function*() {
    try {
      BooongoHubConnection.stop();
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(SignalRTypes.Update_Entity_Balance, function*({ response }) {
    try {
      window.console.response("Balance slot update", response);
      if (response[0]) {
        //window.log("**** Finish **** ", response[0].roundFinished);
        yield put({
          type: SlotsActionTypes.Set_Slots_Round_Finish,
          roundFinished: response[0].roundFinished,
          gameId: response[0].gameId,
          gameName: response[0].gameName,
        });
      }

      if (response && response.length > 0) {
        let { jackpot } = yield select();

        let jackpotWinningApproved = response.some(
          (item) => item.jackpotWinningApproved === true
        );
        yield response.map((item) => {
          let user = Cookies.get("user");
          let selectedCurrency = Cookies.get("selectedCurrency");
          if (user) {
            let balances = user.balance;
            Object.values(balances).map((balance, index) => {
              if (balance.currencyId === item.currencyId) {
                balance.balance = item.balance;
              }
            });

            user.balance = balances;
            Cookies.set("user", user);
            let currentCurrency = Object.keys(balances).find((balance) => {
              return (
                balances[balance].currencySymbol ===
                selectedCurrency.currencySymbol
              );
            });
            Cookies.set("selectedCurrency", balances[currentCurrency]);
            return put({
              type: MembersActionTypes.Member_Update_Balance,
              balance: balances[currentCurrency].balance,
            });
          }
        });
        if (jackpotWinningApproved) {
          const { auth } = yield select();
          if (auth.signedIn)
            yield put({ type: AuthActionTypes.Start_Click_listener });
          yield put({
            type: SignalRTypes.Set_Is_Jackpot_Won,
            currentWin: false,
          });
          SessionStorage.currentWin = false;
        }
        SessionStorage.jackpotWinningApproved = jackpotWinningApproved;
        if (jackpot.jackpotWinningApproved !== jackpotWinningApproved)
          yield put({
            type: SignalRTypes.Jackpot_Winning_Approved,
            jackpotWinningApproved,
          });
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  //******************** Jackpot hub functions *********************//
  yield takeEvery(SignalRTypes.Jackpot_Connect_Success, function*() {
    try {
      window.log("jackpot connect success");
      const { jackpot } = yield select();
      const token = Cookies.get("token");
      if (token) {
        yield JackpotHubConnection.send("JoinGroup", `T2ID${token}_Win`);
        yield JackpotHubConnection.send("JoinGroup", `jGameID${token}_Win`);
        yield JackpotHubConnection.send("JoinGroup", `Web123`);
        yield JackpotHubConnection.send("JoinGroup", `jGame`);
        window.log(`joined: Web123`);
        window.log(`joined: T2ID${token}_Win`);
        window.log(`joined: jGameID${token}_Win`);
        window.log(`joined: Game`);
      } else {
        yield JackpotHubConnection.send("JoinGroup", `Web123`);
        yield JackpotHubConnection.send("JoinGroup", `Web123_Win`);
        yield JackpotHubConnection.send("JoinGroup", `jGame_Win`);
        yield JackpotHubConnection.send("JoinGroup", `jGame`);
        window.log(`joined: Web123`);
        window.log(`joined: Web123_Win`);
        window.log(`joined: jGame_Win`);
        window.log(`joined: jGame`);
      }

      if (jackpot && jackpot.jackpotId) {
        yield JackpotHubConnection.send("JoinGroup", `JAI${jackpot.jackpotId}`);
        window.log(`joined: JAI${jackpot.jackpotId}`);
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Jackpot_Disconnect_Request, function*() {
    try {
      console.log("Jackpot_Disconnect_Request saga");
      const token = Cookies.get("toke");
      const { jackpot } = yield select();

      if (jackpot && jackpot.jackpotId) {
        yield JackpotHubConnection.send("PartGroup", `JAI${jackpot.jackpotId}`);
        window.log(`parted: JAI${jackpot.jackpotId}`);
      }

      if (token) {
        yield JackpotHubConnection.send("PartGroup", `T2ID${token}_Win`);
        yield JackpotHubConnection.send("PartGroup", `jGameID${token}_Win`);
        window.log(`parted: T2ID${token}_Win`);
        window.log(`parted: jGameID${token}_Win`);
      } else {
        yield JackpotHubConnection.send("PartGroup", `Web123`);
        yield JackpotHubConnection.send("PartGroup", `Web123_Win`);
        yield JackpotHubConnection.send("PartGroup", `jGame_Win`);
        yield JackpotHubConnection.send("PartGroup", `jGame`);

        window.log(`parted: Web123`);
        window.log(`parted: Web123_Win`);
        window.log(`parted: jGame_Win`);
        window.log(`parted: jGame`);
      }

      if (JackpotHubConnection) {
        JackpotHubConnection.stop();
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(AuthActionTypes.Signout_Success, function*() {
    try {
      const token = Cookies.get("token");
      SessionStorage.betSlipCouponId = false;
      SessionStorage.couponCodeText = false;
      SessionStorage.couponCode = false;

      if (token) {
        yield MemberChangeConnection.send("PartGroup", `MDT${token}`);
        window.log(`parted: MDT${token}`);
      } else {
        yield JackpotHubConnection.send("PartGroup", `Web123`);
        yield JackpotHubConnection.send("PartGroup", `Web123_Win`);
        yield JackpotHubConnection.send("PartGroup", `jGame_Win`);
        yield JackpotHubConnection.send("PartGroup", `jGame`);

        window.log(`parted: Web123`);
        window.log(`parted: Web123_Win`);
        window.log(`parted: jGame_Win`);
        window.log(`parted: jGame`);
      }

      if (JackpotHubConnection) {
        JackpotHubConnection.stop();
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Jackpot_Winning_Update, function*({ response }) {
    try {
      window.console.response("jackpot winning update", response);
      let won = response.find((item) => {
        if (item.isWon) return item;
      });
      if (won && won.jackpotLevelId == JackpotLevel.Web) {
        const token = Cookies.get("token");
        let winningMessage = null;

        // const currency = Cookies.get('selectedCurrency')

        if (token != null && won.token == token) {
          console.log("member won - ", won.winningMemberMessage);
          winningMessage = won.winningMemberMessage;
        } else {
          console.log("general won - ", won.winningGeneralMessage);
          winningMessage = won.winningGeneralMessage;
        }

        yield put({
          type: SlotsActionTypes.Jackpot_Winning_Success,
          winningMessage: winningMessage,
          winnerJackpotId: won.winnerJackpotId,
        });
        let jackpotWinner = Cookies.get("jackpotWinner");
        //const { jackpot } = yield select()

        //	if (jackpot && jackpot.jackpotId) {
        if (!jackpotWinner) {
          Cookies.set(
            "jackpotWinner",
            {
              jackpogertId: won.winnerJackpotId,
              winningMessage: winningMessage,
            },
            60 * 24
          );
          yield JackpotHubConnection.send(
            "JoinGroup",
            `JAI${won.winnerJackpotId}`
          );
          window.log(`joined: JAI${won.winnerJackpotId}`);
          // yield put({
          // 		type: SlotsActionTypes.Jackpot_Winning_Success,
          // 		//winningMessage: `Congratulations! You Won ${won.payout} ${currency.currencySymbol}, The ${won.jackpotLevelName} Jackpot winner`,
          // 		winnerJackpotId: won.winnerJackpotId
          // 	})
        }

        // if (won.winnerMemberId == memberId) {
        // 	console.log("member won", memberId)
        // 	SessionStorage.currentWin = true;
        // 	yield put({
        // 		type: SlotsActionTypes.Jackpot_Winning_Success,
        // 		winningMessage: `Congratulations! You Won ${won.payout} ${currency.currencySymbol}, The ${won.jackpotLevelName} Jackpot winner`,
        // 		winnerJackpotId: won.winnerJackpotId
        // 	})
        // }
        // else {
        // 	console.log("no member won")
        // 	yield put({
        // 		type: SlotsActionTypes.Jackpot_Winning_Success,
        // 		winningMessage: `The ${won.jackpotLevelName} Jackpot winner, ${won.payout} ${currency.currencySymbol}`,
        // 		winnerJackpotId: won.winnerJackpotId
        // 	})
        // }
        //if (auth.signedIn) yield put({ type: AuthActionTypes.Stop_Click_listener })
      } else if (won && won.jackpotLevelId == JackpotLevel.SingleGame) {
        const token = Cookies.get("token");
        let singleGameWinningMessage = null;

        // const currency = Cookies.get('selectedCurrency')

        if (token != null && won.token == token) {
          console.log("member won - ", won.winningMemberMessage);
          singleGameWinningMessage = won.winningMemberMessage;
        } else {
          console.log("general won - ", won.winningGeneralMessage);
          singleGameWinningMessage = won.winningGeneralMessage;
        }

        yield put({
          type: SlotsActionTypes.Jackpot_Winning_Success,
          singleGameWinningMessage: singleGameWinningMessage,
          winnerJackpotId: won.winnerJackpotId,
        });
        let jackpotWinner = Cookies.get("jackpotWinner");
        if (!jackpotWinner) {
          Cookies.set(
            "jackpotWinner",
            {
              jackpogertId: won.winnerJackpotId,
              singleGameWinningMessage: singleGameWinningMessage,
            },
            60 * 24
          );
          yield JackpotHubConnection.send(
            "JoinGroup",
            `JAI${won.winnerJackpotId}`
          );
          window.log(`joined: JAI${won.winnerJackpotId}`);
        }
      } else {
        yield put({
          type: SlotsActionTypes.Jackpot_Winning_Success,
          winningMessage: null,
        }); //update jackpot balances list.
        SessionStorage.currentWin = false;
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Jackpot_Winning_Update_Join, function*(request) {
    try {
      console.log("Jackpot_Winning_Update_Join", request);
      if (request && request.jackpotId) {
        yield JackpotHubConnection.send("JoinGroup", `JAI${request.jackpotId}`);
        window.log(`joined: JAI${request.jackpotId}`);
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(AppActionTypes.Start, function*() {
    // if we are in the bannerKiosk screen we should connect to the banner kiosk hub only
    const shouldConnectBannerKioskOnly = window.location.pathname.includes(
      "BannerKiosk"
    );
    //
    if (shouldConnectBannerKioskOnly) {
      if (AppConfig.bannerSR) {
        yield put({
          type: SignalRTypes.Connect_to_Banner_Hub,
        });
      }
    } else {
      yield put({
        type: SignalRTypes.Connect_Request,
      });
      if (Cookies.get("token")) {
        if (AppConfig.booongoSRAddress) {
          yield put({ type: SignalRTypes.Booongo_Connect_Request });
        }
        // if (AppConfig.jackpotSRAddress) {
        // 	yield put({ type: SignalRTypes.Jackpot_Connect_Request });
        // }
        if (AppConfig.memberChangeSRAddress) {
          yield put({ type: SignalRTypes.Member_Change_Connect_Request });
        }
      }
      const { signalr } = yield select();
      if (signalr.jackpotRetryConnect) {
        yield put({ type: SignalRTypes.Jackpot_Connect_Request });
      }
    }

    if (AppConfig.staticFeedSR) {
      yield put({ type: SignalRTypes.Static_Connect_Request });
    }

    if (AppConfig.liveFeedSR) {
      yield put({ type: SignalRTypes.Live_Connect_Request });
    }

    if (AppConfig.virtualFeedSR) {
      yield put({ type: SignalRTypes.Virtual_Connect_Request });
    }

    if (AppConfig.spinAndWinFeedSR) {
      yield put({ type: SignalRTypes.SpinAndWin_Connect_Request });
    }

    if (AppConfig.luckyNumbersFeedSR) {
      yield put({ type: SignalRTypes.LuckyNumbers_Connect_Request });
    }

    if (Cookies.get("token")) {
      if (AppConfig.booongoSRAddress) {
        yield put({ type: SignalRTypes.Booongo_Connect_Request });
      }
      // if (AppConfig.jackpotSRAddress) {
      // 	yield put({ type: SignalRTypes.Jackpot_Connect_Request });
      // }
      if (AppConfig.memberChangeSRAddress) {
        yield put({ type: SignalRTypes.Member_Change_Connect_Request });
      }
    }
    const { signalr } = yield select();
    if (signalr.jackpotRetryConnect) {
      yield put({ type: SignalRTypes.Jackpot_Connect_Request });
    }
  });

  yield takeEvery(SignalRTypes.SpinAndWin_Disconnect_Request, function*() {
    try {
      SAWFeedHubConnection.stop();
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.LuckyNumbers_Disconnect_Request, function*() {
    try {
      LuckyNumbersFeedHubConnection.stop();
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Connect_Success, function*() {
    try {
      // console.request("GetAllData", { test: 123 });
      // yield delay(1000);
      // yield hubConnection.send("GetAllCacheData");
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Disconnect_Success, function*() {
    try {
      //hubConnection.start();
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Re_Connect, function*() {
    try {
      clearTimeout(connectInterval);
      yield put(push("/"));
      connect();
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Disconnect_Request, function*() {
    try {
      hubConnection.stop();
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Join_Request, function*({ groupName }) {
    try {
      yield hubConnection.send("JoinGroup", groupName);
      window.log(hubConnection.connection.baseUrl, ` joined: ${groupName}`);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Part_Request, function*({ groupName }) {
    try {
      yield hubConnection.send("PartGroup", groupName);
      window.log(hubConnection.connection.baseUrl, ` parted: ${groupName}`);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.GetAllData_Response, function*({ response }) {
    try {
      console.response("GetAllData", response);
      alert("RESPONSE GET DATA !");
      Database.insertAllData(response);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.KironEvent_Request, function*({ request }) {
    try {
      yield put({
        type: SportEventsActionTypes.SportEvents_OddFields_Success,
        eventOddFields: {},
      });
      yield put({
        type: SportEventsActionTypes.SportEvents_Odds_Success,
        eventOdds: {},
      });
      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });
      window.console.request(
        "KIRONEvent_Request ",
        hubConnection.connection.baseUrl,
        request
      );

      yield hubConnection.send("GetKironEvent", request);
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(SignalRTypes.KironSportEvents_Request, function*({
    request,
  }) {
    try {
      yield put({
        type: SportEventsActionTypes.SportEvents_Events_FeedChange,
        sportEvents: {},
        eventsIds: [],
      });

      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });

      window.console.request(
        "KIRONSportEvents_Request ",
        hubConnection.connection.baseUrl,
        request
      );

      // yield put({ type: SportEventsActionTypes.Init });

      yield hubConnection.send("GetKironEventsList", request);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.SportTypes_Init, function*() {
    try {
      yield put({ type: CategoriesActionTypes.Init });
      yield put({ type: SportEventsActionTypes.Init });
      yield put({ type: SportTypesActionTypes.Init });
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.SportTypes_Request, function*({ request }) {
    try {
      yield put({ type: CategoriesActionTypes.Init });
      yield put({ type: SportEventsActionTypes.Init });

      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });

      window.console.request(
        "REQ SportTypes ",
        hubConnection.connection.baseUrl,
        request
      );
      yield hubConnection.send("GetSportTypes", request);
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(SignalRTypes.Main_Tournament_Events_Request, function*({
    request,
  }) {
    try {
      yield put({ type: CategoriesActionTypes.Init });
      yield put({ type: SportEventsActionTypes.Init });

      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });

      // console.log("Main tournament ============",request);
      // window.console.request("REQ Main_Tournament_Events_Request", request);
      yield hubConnection.invoke("GetMainTournamentEvents");
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(SignalRTypes.OnUpcomingDraws, function*({ request }) {
    try {
      const FavoriteEntities =
        localStorage.getItem("favoriteEntities") &&
        JSON.parse(localStorage.getItem("favoriteEntities"));
      let newRequest = { Data: { ...request.Data, FavoriteEntities } };
      window.console.request(
        "GetUpcomingDraws ",
        hubConnection.connection.baseUrl,
        newRequest
      );
      yield hubConnection.send("GetUpcomingDraws", newRequest);
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(
    SignalRTypes.Get_Draws_Categories_And_Tournaments_Request,
    function*({ request }) {
      try {
        window.console.request(
          "GetDrawsCategoriesAndTournaments ",
          hubConnection.connection.baseUrl,
          request
        );
        yield hubConnection.send("GetDrawsCategoriesAndTournaments", request);
      } catch (e) {
        window.log("ERROR", e);
      }
    }
  );
  yield takeEvery(
    SignalRTypes.Get_Lucky_Numbers_Event_Result_Request,
    function*({ request }) {
      try {
        window.console.request(
          "GetEventResult ",
          hubConnection.connection.baseUrl,
          request
        );
        yield hubConnection.send("GetEventResult", request);
      } catch (e) {
        window.log("ERROR", e);
      }
    }
  );
  yield takeEvery(SignalRTypes.Get_Draw_Odds_Request, function*({ request }) {
    try {
      yield put({ type: SportEventsActionTypes.Init });

      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });
      window.console.request(
        "GetDrawOdds ",
        hubConnection.connection.baseUrl,
        request
      );
      yield hubConnection.send("GetDrawOdds", request);
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(SignalRTypes.Get_Suggested_Balls_Request, function*({
    request,
  }) {
    try {
      window.console.request(
        "GetSuggestedBalls ",
        hubConnection.connection.baseUrl,
        request
      );
      yield hubConnection.send("GetSuggestedBalls", request);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.SportCategories_Request, function*({ request }) {
    try {
      const FavoriteEntities =
        localStorage.getItem("favoriteEntities") &&
        JSON.parse(localStorage.getItem("favoriteEntities"));
      let newRequest = { Data: { ...request.Data, FavoriteEntities } };
      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });

      window.console.request(
        "REQ Categories ",
        hubConnection.connection.baseUrl,
        newRequest
      );
      yield hubConnection.send("GetSportCategories", newRequest);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.SportEvents_Request, function*({ request }) {
    try {
      const FavoriteEntities =
        localStorage.getItem("favoriteEntities") &&
        JSON.parse(localStorage.getItem("favoriteEntities"));

      let newRequest = {
        Data: {
          ...request.Data,
          FavoriteEntities,
        },
      };
      window.console.request(
        "SportEvents_Request ",
        hubConnection.connection.baseUrl,
        newRequest
      );

      yield put({ type: SportEventsActionTypes.Init });

      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });

      yield hubConnection.send("GetSportEvents", newRequest);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.TopBets_Request, function*({ request }) {
    try {
      const FavoriteEntities =
        localStorage.getItem("favoriteEntities") &&
        JSON.parse(localStorage.getItem("favoriteEntities"));

      let newRequest = {
        Data: {
          ...request.Data,
          FavoriteEntities,
        },
      };
      window.console.request(
        "TopBets_Request ",
        hubConnection.connection.baseUrl,
        newRequest
      );

      yield put({ type: SportEventsActionTypes.Init });

      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });

      yield hubConnection.send("GetTopBets", newRequest);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.SportEventsVirtual_Request, function*({ data }) {
    try {
      let request = {
        Data: {
          Feed: { FeedId: Number(data.FeedId) },
          Sport: { SportId: Number(data.SportId) },
          MatchDay: Number(data.MatchDay),
          Season: Number(data.Season),
        },
      };

      window.console.request(
        "Virtual Events ",
        hubConnection.connection.baseUrl,
        request
      );

      yield put({ type: SportEventsActionTypes.Init });

      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });

      yield hubConnection.send("GetVirtualEvents", request);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.SportEvents_By_Date_Request, function*({
    request,
  }) {
    try {
      const FavoriteEntities =
        localStorage.getItem("favoriteEntities") &&
        JSON.parse(localStorage.getItem("favoriteEntities"));

      let newRequest = {
        Data: {
          ...request.Data,
          FavoriteEntities,
        },
      };
      yield put({ type: SportEventsActionTypes.Init });

      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });

      window.console.request(
        "REQ Sport Events By Date ",
        hubConnection.connection.baseUrl,
        newRequest
      );

      yield hubConnection.send("GetSportEventsByDate", newRequest);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SearchActionTypes.GetSearchedData_Request, function*({
    request,
  }) {
    try {
      window.console.request(
        "search data ",
        hubConnection.connection.baseUrl,
        hubConnection.connection.baseUrl,
        request
      );

      yield hubConnection.send("GetSearchedData", request);
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.AllBetTypes_Request, function*({ request }) {
    try {
      yield put({ type: SportEventsActionTypes.Init });

      yield put({
        type: SignalRTypes.Handle_Join_Part_Groups,
        data: request.Data,
      });

      window.console.request(
        "All BetTypes ",
        hubConnection.connection.baseUrl,
        request
      );

      yield hubConnection.send("GetAllBetTypes", request);
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(
    SportEventsActionTypes.Sport_Get_Week_Match_Days_Request,
    function*({ request }) {
      try {
        window.console.request(
          "GetWeekMatchDays ",
          StaticFeedHubConnection,
          request
        );
        yield StaticFeedHubConnection.send("GetWeekMatchDays", request);
      } catch (e) {
        window.log("ERROR in GetWeekMatchDays", e);
      }
    }
  );
  yield takeEvery(
    SportEventsActionTypes.Get_Default_Live_Sport_Type_Request,
    function*() {
      try {
        let request = {
          Data: {
            Feed: {
              FeedId: 5,
            },
          },
        };
        window.console.request(
          "Req => GetLiveDefaultSportType ",
          hubConnection.connection.baseUrl,
          request
        );
        yield hubConnection.send("GetLiveDefaultSportType", request);
      } catch (e) {
        window.log("ERROR in GetLiveDefaultSportType", e);
      }
    }
  );

  yield takeEvery(SignalRTypes.Get_Updated_OddField_Details, function*({
    request,
  }) {
    try {
      window.log("request", request);
      const { signalr } = yield select();

      let requestStatic = request.filter(
        (req) => req.feed.feedId == Enums.Feed.Static
      );
      let requestVirtual = request.filter(
        (req) =>
          req.feed.feedId == Enums.Feed.EPL ||
          req.feed.feedId == Enums.Feed.VBL ||
          req.feed.feedId == Enums.Feed.VDR ||
          req.feed.feedId == Enums.Feed.VFL ||
          req.feed.feedId == Enums.Feed.VFLM ||
          req.feed.feedId == Enums.Feed.VHC ||
          req.feed.feedId == Enums.Feed.VTO
      );
      let requestLuckyNumbers = request.filter(
        (req) => req.feed.feedId == Enums.Feed.LuckyNumbers
      );
      let requestSpinAndWin = request.filter(
        (req) =>
          req.feed.feedId == Enums.Feed.Casino ||
          req.feed.feedId == Enums.Feed.SpinAndWin
      );
      let requestLive = request.filter(
        (req) => req.feed.feedId == Enums.Feed.Live
      );
      window.log("requestVirtual", requestVirtual);
      window.log("requestStatic", requestStatic);

      if (
        signalr.staticConnected &&
        requestStatic &&
        requestStatic.length > 0
      ) {
        window.console.request(
          "REQ Bet Slip details ",
          StaticFeedHubConnection.connection.baseUrl,
          requestStatic
        );
        yield StaticFeedHubConnection.send(
          "GetEventOddFieldData",
          requestStatic
        );
      }

      if (
        signalr.virtualConnected &&
        requestVirtual &&
        requestVirtual.length > 0
      ) {
        window.console.request(
          "REQ Bet Slip details ",
          VirtualFeedHubConnection.connection.baseUrl,
          requestVirtual
        );
        yield VirtualFeedHubConnection.send(
          "GetEventOddFieldData",
          requestVirtual
        );
      }

      if (
        signalr.luckyNumbersConnected &&
        requestLuckyNumbers &&
        requestLuckyNumbers.length > 0
      ) {
        window.console.request(
          "REQ Bet Slip details ",
          LuckyNumbersFeedHubConnection.connection.baseUrl,
          requestLuckyNumbers
        );
        yield LuckyNumbersFeedHubConnection.send(
          "GetEventOddFieldData",
          requestLuckyNumbers
        );
      }

      if (
        signalr.spinAndWinConnected &&
        requestSpinAndWin &&
        requestSpinAndWin.length > 0
      ) {
        window.console.request(
          "REQ Bet Slip details ",
          SAWFeedHubConnection.connection.baseUrl,
          requestSpinAndWin
        );
        yield SAWFeedHubConnection.send(
          "GetEventOddFieldData",
          requestSpinAndWin
        );
      }

      if (signalr.liveConnected && requestLive && requestLive.length > 0) {
        window.console.request(
          "REQ Bet Slip details ",
          LiveFeedHubConnection.connection.baseUrl,
          requestLive
        );
        yield LiveFeedHubConnection.send("GetEventOddFieldData", requestLive);
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Handle_Join_Part_Groups, function*({
    data,
    isPartOnly,
  }) {
    try {
      const { sport, betSlip } = yield select();
      let joinedGroupsCopy = sport.joinedGroups
        ? Utils.deepClone(sport.joinedGroups)
        : [];

      yield joinedGroupsCopy &&
        joinedGroupsCopy.length > 0 &&
        joinedGroupsCopy.map((item) => {
          // if event join, check if exist in betslip, if yes don't part, to keep getting feed change
          if (item.indexOf("E") > -1) {
            let betSlipFields = Object.values(betSlip.betSlipList);
            let eventJoinedId = item.substring(item.lastIndexOf("E") + 1);
            if (
              betSlipFields.find(
                (item) => item.eventId.toString() === eventJoinedId
              )
            ) {
              return;
            }
          }
          return put({
            type: SignalRTypes.Part_Request,
            groupName: item,
          });
        });
      yield put({
        type: SignalRTypes.Set_Join_Groups,
        joinedGroups: [],
      });

      if (!isPartOnly) {
        let keyList = Utils.generateGroupKeys(data);

        let newGroups = [];

        yield keyList &&
          keyList.length > 0 &&
          keyList.map((item) => {
            if (item) {
              newGroups.push(item);
              return put({
                type: SignalRTypes.Join_Request,
                groupName: item,
              });
            }
          });
        yield put({
          type: SignalRTypes.Set_Join_Groups,
          joinedGroups: newGroups,
        });
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeEvery(SignalRTypes.Jackpot_Balance_Update, function*({ response }) {
    try {
      let { jackpot } = yield select();
      let balances = jackpot.jackpotBalances;
      console.response("jackpot balances update", response);
      var result =
        response &&
        response.reduce(function(jackpot, obj) {
          balances[obj.jackpotLevelId] = obj;
          return { ...balances };
        }, {});

      yield put({
        type: SignalRTypes.Jackpot_Balance_Success,
        jackpotBalances: result,
      });
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(SignalRTypes.Jackpot_Approval_Update_Request, function*({
    response,
  }) {
    try {
      let { jackpot } = yield select();
      let balances = jackpot.jackpotBalances;
      console.response("jackpot approval update", response);
      // var result = response && response.reduce(function (jackpot, obj) {
      // 	balances[obj.jackpotLevelId] = obj;
      // 	return { ...balances }
      // }, {});

      //let jackpotWinner = Cookies.get("jackpotWinner");
      if (jackpot && jackpot.jackpotId) {
        //jackpotWinner) {
        //Cookies.remove("jackpotWinner");
        // yield JackpotHubConnection.send("PartGroup", `JAI${jackpotWinner.jackpotId}`);
        // window.log(`parted: JAI${jackpotWinner.jackpotId}`)
        yield JackpotHubConnection.send("PartGroup", `JAI${jackpot.jackpotId}`);
        window.log(`parted: JAI${jackpot.jackpotId}`);
      }

      yield put({
        type: SignalRTypes.Jackpot_Approval_Update_Success,
      });
    } catch (e) {
      window.log("ERROR", e);
    }
  });
}

export default function* signalRSaga() {
  yield all([fork(requests)]);
}
